// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   Plus, Edit2, Trash2, X, Save, AlertTriangle,
//   Power, Wifi, MapPin, Code, Key, Cpu, Users, User,
//   ChevronDown, ChevronUp, History, Activity, XCircle,
//   Check as CheckIcon, Loader2
// } from 'lucide-react';
// import StandardSpinner from '../../../utils/Spinner';
// import useSocket from '../../../hooks/useSocket';
// import { ACCOUNT_TYPE } from '../../../utils/Account_Type';
// import {
//   Get_Devices,
//   Create_Devices,
//   Update_Devices,
//   Delete_Devices,
//   Unenroll_Users_From_device,
//   Delete_Users_From_device,
//   Get_Org_Devices,
//   Create_Org_Device,
//   Update_Org_Device,
//   Delete_Org_Device,
//   Get_Device_History
// } from '../../../services/oprations/Device';
// import { useToast } from '../../Toast';

// const DeviceManagement = () => {
//   const toast = useToast();
//   const [text, setText] = useState("")
//   const [selectedDevice, setSelectedDevice] = useState({});
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isFormModalOpen, setIsFormModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [isUnenrollModalOpen, setIsUnenrollModalOpen] = useState(false);
//   const [isDeleteUserModalOpen, setIsDeleteUserModalOpen] = useState(false);
//   const [deleteUserFromDevice, setDeleteUserFromDevice] = useState(null);
//   const [deviceToDelete, setDeviceToDelete] = useState(null);
//   const [deviceToUnenroll, setDeviceToUnenroll] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [formLoading, setFormLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [formMode, setFormMode] = useState('create');
//   const [formData, setFormData] = useState({
//     device_name: '',
//     device_code: '',
//     secret_key: '',
//     device_location: '',
//     device_firmware_version: '',
//     managerId: '',
//   });
//   const [formErrors, setFormErrors] = useState({});
//   const [expandedDeviceRows, setExpandedDeviceRows] = useState({});

//   // ── Device history state ──────────────────────────────────────────────
//   const [deviceHistoryMap, setDeviceHistoryMap] = useState({});
//   const [loadingHistoryMap, setLoadingHistoryMap] = useState({});

//   // ── Multi-select / bulk delete ──────────────────────────────────────────
//   const [selectedIds, setSelectedIds] = useState(new Set());
//   const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
//   const [isBulkDeleting, setIsBulkDeleting] = useState(false);
//   const [bulkProgress, setBulkProgress] = useState({ current: 0, total: 0 });

//   const { devices } = useSelector((state) => state.device);
//   const { token } = useSelector((state) => state.auth);
//   const { managers } = useSelector((state) => state.manager);
//   const { user } = useSelector((state) => state.profile);
//   const userData = typeof user === 'string' ? JSON.parse(user) : user;

//   const role = userData?.role;
//   const managersList = typeof managers === 'string' ? JSON.parse(managers) : (managers || []);

//   const dispatch = useDispatch();
//   const socket = useSocket();

//   useEffect(() => { fetchDevices(); }, [dispatch, token, role]);

//   const fetchDevices = () => {
//     if (role === ACCOUNT_TYPE.ORGANIZATION) {
//       dispatch(Get_Org_Devices(token));
//     } else if (role === ACCOUNT_TYPE.MANAGER) {
//       dispatch(Get_Devices(token));
//     } else {
//       dispatch(Get_Org_Devices(token));
//     }
//   };

//   // ── Fetch device history ───────────────────────────────────────────────
//   const fetchDeviceHistory = async (deviceId) => {
//     if (loadingHistoryMap[deviceId]) return;

//     setLoadingHistoryMap(prev => ({ ...prev, [deviceId]: true }));

//     try {
//       console.log("Fetching history for deviceId:", deviceId);
//       const res = await dispatch(Get_Device_History(deviceId));
//       console.log("Full raw response:", JSON.stringify(res, null, 2));

//       const rawData = res?.data?.data;
//       console.log("rawData:", rawData);
//       console.log("rawData length:", rawData?.length);

//       if (res?.data?.success && Array.isArray(rawData) && rawData.length > 0) {
//         const historyData = rawData.map(entry => {
//           console.log("Entry fields:", Object.keys(entry), entry);
//           return {
//             _id:        entry._id,
//             status:     entry.status,
//             lastseenAt: entry.lastseenAt,
//             deviceName: entry.deviceName,
//             deviceId:   entry.deviceId,
//             managerId:  entry.managerId,
//             orgId:      entry.orgId,
//           };
//         });
//         setDeviceHistoryMap(prev => ({ ...prev, [deviceId]: historyData }));
//       } else {
//         console.warn("No data or success=false. res.data:", res?.data);
//         setDeviceHistoryMap(prev => ({ ...prev, [deviceId]: [] }));
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setDeviceHistoryMap(prev => ({ ...prev, [deviceId]: [] }));
//     } finally {
//       setLoadingHistoryMap(prev => ({ ...prev, [deviceId]: false }));
//     }
//   };

//   // Toggle row expansion and lazy-load history
//   const toggleDeviceRow = async (id) => {
//     const isExpanding = !expandedDeviceRows[id];
//     setExpandedDeviceRows(prev => ({ ...prev, [id]: isExpanding }));
//     if (isExpanding && !deviceHistoryMap[id] && !loadingHistoryMap[id]) {
//       await fetchDeviceHistory(id);
//     }
//   };

//   useEffect(() => {
//     if (!socket) return;
//     socket.on("Device_Status", () => { fetchDevices(); });
//     return () => { socket.off("Device_Status"); };
//   }, [socket, dispatch, token, role]);

//   useEffect(() => {
//     setTimeout(() => { setLoading(false); }, 800);
//   }, []);

//   // ── Selection helpers ───────────────────────────────────────────────────
//   const filteredDevices = devices.filter(device => {
//     const matchesSearch =
//       device.device_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       device.device_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       device.device_location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       device.device_firmware_version?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       (device.device_manager_id?.manager_name?.toLowerCase() || '').includes(searchTerm.toLowerCase());

//     const matchesStatus =
//       filterStatus === 'all' ||
//       (filterStatus === 'ONLINE' && (device.last_status === 'ONLINE' || device.last_status === 'HEARTBEAT')) ||
//       (filterStatus === 'OFFLINE' && device.last_status === 'OFFLINE');

//     return matchesSearch && matchesStatus;
//   });

//   const allFilteredSelected = filteredDevices.length > 0 && filteredDevices.every(d => selectedIds.has(d._id));
//   const someSelected = selectedIds.size > 0;

//   const toggleSelectAll = () => {
//     if (allFilteredSelected) {
//       setSelectedIds(prev => {
//         const next = new Set(prev);
//         filteredDevices.forEach(d => next.delete(d._id));
//         return next;
//       });
//     } else {
//       setSelectedIds(prev => {
//         const next = new Set(prev);
//         filteredDevices.forEach(d => next.add(d._id));
//         return next;
//       });
//     }
//   };

//   const toggleSelectDevice = (e, deviceId) => {
//     e.stopPropagation();
//     setSelectedIds(prev => {
//       const next = new Set(prev);
//       next.has(deviceId) ? next.delete(deviceId) : next.add(deviceId);
//       return next;
//     });
//   };

//   const clearSelection = () => setSelectedIds(new Set());

//   // ── Bulk delete ─────────────────────────────────────────────────────────
//   const handleBulkDeleteConfirm = async () => {
//     const ids = [...selectedIds];
//     setIsBulkDeleting(true);
//     setBulkProgress({ current: 0, total: ids.length });

//     let successCount = 0;
//     let errorCount = 0;

//     for (let i = 0; i < ids.length; i++) {
//       setBulkProgress({ current: i + 1, total: ids.length });
//       try {
//         const res = role === ACCOUNT_TYPE.ORGANIZATION
//           ? await dispatch(Delete_Org_Device(ids[i]))
//           : await dispatch(Delete_Devices(ids[i]));
//         if (res?.data?.success) successCount++;
//         else errorCount++;
//       } catch {
//         errorCount++;
//       }
//     }

//     if (successCount > 0) toast.success(`Deleted ${successCount} device${successCount > 1 ? 's' : ''}${errorCount > 0 ? `, ${errorCount} failed` : ''} successfully`);
//     if (errorCount > 0 && successCount === 0) toast.error(`Failed to delete ${errorCount} device${errorCount > 1 ? 's' : ''}`);

//     await fetchDevices();
//     setIsBulkDeleting(false);
//     setIsBulkDeleteOpen(false);
//     setBulkProgress({ current: 0, total: 0 });
//     clearSelection();
//   };

//   // ── Duration helper using lastseenAt ────────────────────────────────────
//   const formatDuration = (startTime, endTime) => {
//     if (!startTime) return '';
    
//     const diffMs = (endTime ? new Date(endTime) : new Date()) - new Date(startTime);
//     if (diffMs < 0) return '';

//     const hours = Math.floor(diffMs / 3600000);
//     const minutes = Math.floor((diffMs % 3600000) / 60000);
//     const seconds = Math.floor((diffMs % 60000) / 1000);

//     return `${hours ? `${hours}h ` : ''}${minutes}m ${seconds}s`;
//   };

//   const handleDeviceClick = (device) => { setSelectedDevice(device); setIsModalOpen(true); };

//   const handleEditClick = (e, device) => {
//     e.stopPropagation();
//     setFormMode('edit');
//     setFormData({
//       device_name: device.device_name || '',
//       device_code: device.device_code || '',
//       secret_key: device.secret_key || '',
//       device_location: device.device_location || '',
//       device_firmware_version: device.device_firmware_version || '',
//       managerId: device.device_manager_id?._id || device.device_manager_id || '',
//       _id: device._id
//     });
//     setIsFormModalOpen(true);
//   };

//   const handleDeleteClick = (e, device) => {
//     e.stopPropagation();
//     setDeviceToDelete(device);
//     setIsDeleteModalOpen(true);
//   };

//   const handleAddClick = () => {
//     setFormMode('create');
//     setFormData({ device_name: '', device_code: '', secret_key: '', device_location: '', device_firmware_version: '', managerId: '' });
//     setFormErrors({});
//     setIsFormModalOpen(true);
//   };

//   const handleUnenrollClick = (device) => { setDeviceToUnenroll(device); setIsUnenrollModalOpen(true); };
//   const handleDeleteUserClick = (device) => { setDeleteUserFromDevice(device); setIsDeleteUserModalOpen(true); };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.device_name.trim()) errors.device_name = 'Device name is required';
//     if (!formData.device_code.trim()) errors.device_code = 'Device code is required';
//     if (!formData.secret_key.trim()) errors.secret_key = 'Secret key is required';
//     if (!formData.device_location.trim()) errors.device_location = 'Location is required';
//     if (!formData.device_firmware_version.trim()) errors.device_firmware_version = 'Firmware version is required';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     if (formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: '' }));
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setFormLoading(true);
//     try {
//       let res;
//       if (role === ACCOUNT_TYPE.ORGANIZATION) {
//         res = formMode === 'create' ? await dispatch(Create_Org_Device(formData)) : await dispatch(Update_Org_Device(formData._id, formData));
//       } else {
//         res = formMode === 'create' ? await dispatch(Create_Devices(formData)) : await dispatch(Update_Devices(formData));
//       }
//       setIsFormModalOpen(false);
//       setFormData({ device_name: '', device_code: '', secret_key: '', device_location: '', device_firmware_version: '', managerId: '' });
//       if (res?.data?.success) { toast.success(res.data.message); fetchDevices(); }
//       else toast.error(res?.data?.message || 'Error saving device');
//     } catch (error) {
//       toast.error('Error saving device');
//     } finally { setFormLoading(false); }
//   };

//   const handleDeleteConfirm = async () => {
//     if (!deviceToDelete) return;
//     setFormLoading(true);
//     try {
//       const res = role === ACCOUNT_TYPE.ORGANIZATION
//         ? await dispatch(Delete_Org_Device(deviceToDelete._id))
//         : await dispatch(Delete_Devices(deviceToDelete._id));
//       setIsDeleteModalOpen(false);
//       setDeviceToDelete(null);
//       if (res?.data?.success) { toast.success('Device deleted successfully'); fetchDevices(); }
//       else toast.error(res?.data?.message || 'Error deleting device');
//     } catch (error) {
//       toast.error('Error deleting device');
//     } finally { setFormLoading(false); }
//   };

//   const handleUnenrollConfirm = async () => {
//     if (!deviceToUnenroll) return;
//     setFormLoading(true);
//     try {
//       const res = await dispatch(Unenroll_Users_From_device(deviceToUnenroll._id));
//       setIsUnenrollModalOpen(false);
//       setDeviceToUnenroll(null);
//       fetchDevices();
//       if (res?.data?.success) toast.success(res.data.message);
//       else toast.error(res?.data?.message || 'Error unenrolling users');
//     } catch (error) {
//       toast.error('Error unenrolling users');
//     } finally { setFormLoading(false); }
//   };

//   const handleDeleteUsers = async () => {
//     if (!deleteUserFromDevice) return;
//     setFormLoading(true);
//     try {
//       const res = await dispatch(Delete_Users_From_device(deleteUserFromDevice._id));
//       setIsDeleteUserModalOpen(false);
//       setDeleteUserFromDevice(null);
//       fetchDevices();
//       if (res?.data?.success) toast.success(res.data.message);
//       else toast.error(res?.data?.message || 'Error deleting users');
//     } catch (error) {
//       toast.error('Error deleting users');
//     } finally { setFormLoading(false); }
//   };

//   const closeModals = () => {
//     setIsModalOpen(false); setIsFormModalOpen(false); setIsDeleteModalOpen(false);
//     setIsUnenrollModalOpen(false); setIsDeleteUserModalOpen(false);
//     setDeviceToDelete(null); setDeviceToUnenroll(null); setDeleteUserFromDevice(null);
//     setSelectedDevice(null); setFormErrors({});
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
//   };

//   const getStatusBadge = (status) =>
//     status === 'ONLINE' || status === 'HEARTBEAT'
//       ? 'bg-green-900/50 text-green-300 border border-green-700/50'
//       : 'bg-red-900/50 text-red-300 border border-red-700/50';

//   const getLastStatusBadge = (status) =>
//     status === 'ONLINE' || status === 'HEARTBEAT'
//       ? 'bg-green-900/50 text-green-300 border border-green-700/50'
//       : 'bg-gray-900/50 text-gray-300 border border-gray-700/50';

//   const calculateDurationMs = (startTime, endTime) => {
//     if (!startTime) return 0;
//     const end = endTime ? new Date(endTime) : new Date();
//     const start = new Date(startTime);
//     return Math.max(0, end - start);
//   };

//   const formatDurationFromMs = (ms) => {
//     const hours = Math.floor(ms / 3600000);
//     const minutes = Math.floor((ms % 3600000) / 60000);
//     const seconds = Math.floor((ms % 60000) / 1000);
//     return `${hours ? `${hours}h ` : ''}${minutes}m ${seconds}s`;
//   };

//   const formatDateTimeHelper = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleString([], { 
//       day: '2-digit', 
//       month: 'short', 
//       hour: '2-digit', 
//       minute: '2-digit', 
//       second: '2-digit' 
//     });
//   };

//   // ── DEVICE STATUS HISTORY PANEL ────────────────────────────────────────────────
//   const StatusHistoryPanel = ({ device }) => {
//     const history = deviceHistoryMap[device._id];
//     const isLoading = loadingHistoryMap[device._id];
//     const [isRefreshing, setIsRefreshing] = useState(false);

//     // Process history entries to calculate durations correctly
//     const groupedHistory = React.useMemo(() => {
//       if (!history || history.length === 0) return [];

//       // Sort ascending (oldest → newest)
//       const sorted = [...history].sort((a, b) => new Date(a.lastseenAt) - new Date(b.lastseenAt));

//       // Calculate durations by pairing status entries with their next occurrence
//       const calculatedDurations = [];
      
//       for (let i = 0; i < sorted.length; i++) {
//         const currentEntry = sorted[i];
//         const nextEntry = sorted[i + 1];
        
//         let endTime = null;
        
//         // If there's a next entry, duration is until that entry
//         if (nextEntry) {
//           endTime = nextEntry.lastseenAt;
//         }
//         // Last entry - ongoing duration
//         else {
//           endTime = null; // null means ongoing/present
//         }
        
//         calculatedDurations.push({
//           status: currentEntry.status,
//           startTime: currentEntry.lastseenAt,
//           endTime: endTime,
//           rawEntry: currentEntry
//         });
//       }
      
//       // Now group consecutive same-status entries and sum their durations
//       const groups = [];
//       let currentGroup = null;
      
//       for (const entry of calculatedDurations) {
//         if (!currentGroup || currentGroup.status !== entry.status) {
//           // Start new group
//           if (currentGroup) groups.push(currentGroup);
//           currentGroup = {
//             status: entry.status,
//             startTime: entry.startTime,
//             endTime: entry.endTime,
//             durationMs: calculateDurationMs(entry.startTime, entry.endTime),
//             entries: [entry]
//           };
//         } else {
//           // Same status - extend the group
//           currentGroup.endTime = entry.endTime;
//           currentGroup.durationMs += calculateDurationMs(entry.startTime, entry.endTime);
//           currentGroup.entries.push(entry);
//         }
//       }
//       if (currentGroup) groups.push(currentGroup);
      
//       // Convert to display format and reverse for most recent first
//       return groups.reverse().map(group => ({
//         ...group,
//         duration: formatDurationFromMs(group.durationMs),
//         startDisplay: formatDateTimeHelper(group.startTime),
//         endDisplay: group.endTime === null ? 'Present' : formatDateTimeHelper(group.endTime),
//         isPresent: group.endTime === null
//       }));
//     }, [history]);

//     // Manual refresh function
//     const handleRefreshHistory = async () => {
//       if (isRefreshing || isLoading) return;
//       setIsRefreshing(true);
//       try {
//         setDeviceHistoryMap(prev => ({ ...prev, [device._id]: undefined }));
//         setLoadingHistoryMap(prev => ({ ...prev, [device._id]: true }));
//         await fetchDeviceHistory(device._id);
//         toast.success('History refreshed successfully');
//       } catch (error) {
//         console.error("Error refreshing history:", error);
//         toast.error('Failed to refresh history');
//       } finally {
//         setIsRefreshing(false);
//       }
//     };

//     return (
//       <div>
//         <div className="flex items-center gap-2 mb-3">
//           <History className="flex-shrink-0 w-4 h-4 text-blue-400" />
//           <h4 className="text-sm font-medium text-blue-300">Device Status History</h4>
//           {groupedHistory.length > 0 && (
//             <span className="text-xs px-2 py-0.5 rounded-full bg-blue-800/40 text-blue-400/70">
//               {groupedHistory.length} events · {history?.length || 0} records
//             </span>
//           )}
          
//           {/* Refresh Button */}
//           <button
//             onClick={handleRefreshHistory}
//             disabled={isRefreshing || isLoading}
//             className="ml-auto p-1.5 text-blue-400 transition-colors rounded-lg hover:bg-blue-600/20 disabled:opacity-50 disabled:cursor-not-allowed"
//             title="Refresh history"
//           >
//             {isRefreshing ? (
//               <Loader2 className="w-4 h-4 animate-spin" />
//             ) : (
//               <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//               </svg>
//             )}
//           </button>
//         </div>

//         {(isLoading || isRefreshing) ? (
//           <div className="flex items-center justify-center py-6">
//             <Loader2 className="w-5 h-5 text-blue-400 animate-spin" />
//             <span className="ml-2 text-sm text-blue-400/70">
//               {isRefreshing ? 'Refreshing history...' : 'Loading history...'}
//             </span>
//           </div>

//         ) : groupedHistory.length > 0 ? (
//           <div className="flex flex-col gap-1.5 max-h-64 overflow-y-auto pr-1">
//             {groupedHistory.map((group, idx) => {
//               const isOnline = group.status === 'ONLINE' || group.status === 'HEARTBEAT';
              
//               return (
//                 <div
//                   key={idx}
//                   className={`flex flex-wrap items-center gap-2 text-xs px-3 py-2 rounded-lg border ${
//                     isOnline
//                       ? 'bg-green-500/5 border-green-500/15'
//                       : 'bg-gray-500/5 border-gray-500/15'
//                   }`}
//                 >
//                   {/* Icon */}
//                   <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 ${
//                     isOnline ? 'bg-green-500/20 text-green-400' : 'bg-gray-500/20 text-gray-400'
//                   }`}>
//                     {isOnline ? <Activity className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />}
//                   </div>

//                   {/* Status */}
//                   <span className={`font-bold w-16 flex-shrink-0 ${isOnline ? 'text-green-400' : 'text-gray-400'}`}>
//                     {group.status}
//                   </span>

//                   {/* Time range */}
//                   <div className="flex flex-col min-w-0">
//                     <span className="text-blue-300/70">
//                       {group.isPresent 
//                         ? `${group.startDisplay} → Present`
//                         : `${group.startDisplay} → ${group.endDisplay}`}
//                     </span>
//                     {group.entries.length > 1 && (
//                       <span className="text-blue-400/40 text-[11px]">
//                         (combined {group.entries.length} consecutive {group.entries.length === 1 ? 'event' : 'events'})
//                       </span>
//                     )}
//                   </div>

//                   {/* Duration badge */}
//                   <span className={`ml-auto px-2.5 py-1 rounded-full text-[11px] font-semibold border flex-shrink-0 ${
//                     isOnline
//                       ? 'bg-green-500/10 text-green-400 border-green-500/30'
//                       : 'bg-gray-500/10 text-gray-400 border-gray-500/30'
//                   }`}>
//                     {isOnline ? '🟢' : '⚫'} {group.duration}
//                   </span>
//                 </div>
//               );
//             })}
//           </div>

//         ) : history && history.length === 0 ? (
//           <p className="text-xs italic text-blue-400/50">No device status history available for this device.</p>
//         ) : (
//           <p className="text-xs italic text-blue-400/50">Click the chevron to load history...</p>
//         )}
//       </div>
//     );
//   };

//   // ── MOBILE DEVICE CARD ──────────────────────────────────────────────────
//   const DeviceCard = ({ device, isSelected, onSelect }) => {
//     const isOnline = device.last_status === 'ONLINE' || device.last_status === 'HEARTBEAT';
//     const expanded = expandedDeviceRows[device._id];
//     return (
//       <div className={`overflow-hidden border rounded-xl transition-colors ${
//         isSelected
//           ? 'bg-red-900/15 border-red-700/50'
//           : 'border-blue-700/60 bg-richblue-800/20'
//       }`}>
//         <div
//           className="flex items-center p-2 transition-colors cursor-pointer hover:bg-blue-950/30"
//           onClick={() => handleDeviceClick(device)}
//         >
//           <input
//             type="checkbox"
//             checked={isSelected}
//             onChange={(e) => onSelect(e, device._id)}
//             onClick={(e) => e.stopPropagation()}
//             className="flex-shrink-0 w-4 h-4 mr-1 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//           />
//           <button
//             className="flex-shrink-0 p-1 text-blue-400 transition-colors rounded hover:bg-blue-800/30"
//             onClick={(e) => { e.stopPropagation(); toggleDeviceRow(device._id); }}
//             title="View device status history"
//           >
//             {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
//           </button>
//           <div className="flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//             {device.device_name?.charAt(0) || 'D'}
//           </div>
//           <div className="flex-1 min-w-0">
//             <p className="pl-2 text-sm font-medium text-white truncate">{device.device_name}</p>
//             <p className="pl-2 text-xs text-gray-400 truncate">{device.device_location}</p>
//           </div>
//           <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-xs font-semibold ${getLastStatusBadge(device.last_status)}`}>
//             {device.last_status}
//           </span>
//         </div>

//         <div className="flex flex-wrap items-center justify-between px-3 pb-2 text-xs border-t border-b-2 gap-x-4 gap-y-1 text-blue-300/70 border-blue-800/30 pt-1.5">
//           <p className='text-xs text-gray-500'>Code: <span className="font-extralight">{device.device_code}</span></p>
//           <p className='text-xs text-gray-500'>Firmware: <span className='font-extralight'>{device.device_firmware_version}</span></p>
//           <p className='text-xs text-gray-500'>Users: <span className="text-blue-200 font-extralight">{device.users_count || 0} user(s)</span></p>
//           {role === ACCOUNT_TYPE.ORGANIZATION && device.device_manager_id?.manager_name && (
//             <p className='text-xs text-gray-500'>Manager: <span className="text-blue-200 font-extralight">{device.device_manager_id.manager_name}</span></p>
//           )}
//           <p className='text-xs text-gray-500'>Last seen: <span className="font-extralight">{formatDate(device.device_last_seen)}</span></p>
//         </div>

//         {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//           <div className="flex justify-end gap-2 px-3 pb-3 mt-2">
//             <button
//               onClick={(e) => handleEditClick(e, device)}
//               className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-yellow-400 rounded-lg bg-yellow-600/20 hover:bg-yellow-600/30 transition-colors"
//             >
//               <Edit2 className="w-3.5 h-3.5" /> Edit
//             </button>
//             <button
//               onClick={(e) => handleDeleteClick(e, device)}
//               className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-red-400 rounded-lg bg-red-600/20 hover:bg-red-600/30 transition-colors"
//             >
//               <Trash2 className="w-3.5 h-3.5" /> Delete
//             </button>
//           </div>
//         )}

//         {expanded && (
//           <div className="px-3 pt-2 pb-3 border-t border-blue-500/20 bg-white/5">
//             <StatusHistoryPanel device={device} />
//           </div>
//         )}
//       </div>
//     );
//   };

//   if (loading) return <StandardSpinner />;

//   const totalCols =
//     role === ACCOUNT_TYPE.ORGANIZATION ? 11
//     : (role === ACCOUNT_TYPE.MANAGER ? 10 : 9);

//   return (
//     <div className="flex flex-col h-full font-sans text-white bg-richblue-950">

//       {/* ── HEADER ── */}
//       <div className="flex-none p-3 md:p-4 bg-richblue-950">
//         <div className="flex items-center justify-between mb-4">
//           <h1 className="text-xl font-bold text-transparent md:text-2xl bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text">
//             Device Management
//           </h1>
//           {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//             <button
//               onClick={handleAddClick}
//               className="flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-2 text-sm font-medium text-white shadow-lg bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 rounded-xl shadow-blue-600/25"
//             >
//               <Plus className="w-4 h-4" />
//               <span className="hidden sm:inline">Add Device</span>
//               <span className="sm:hidden">Add</span>
//             </button>
//           )}
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-2 gap-2 mb-3 sm:mb-4 md:grid-cols-4 md:gap-3">
//           <div className="p-3 border md:p-4 bg-richblue-600/20 border-blue-700/80 rounded-xl">
//             <p className="text-xs text-blue-300 md:text-sm">Total Devices</p>
//             <p className="mt-1 text-xl font-bold text-white md:text-2xl">{devices.length}</p>
//           </div>
//           <div className="p-3 border md:p-4 bg-richblue-600/20 border-blue-700/80 rounded-xl">
//             <p className="text-xs text-blue-300 md:text-sm">Active</p>
//             <p className="mt-1 text-xl font-bold text-green-400 md:text-2xl">
//               {devices.filter(d => d.last_status === 'HEARTBEAT' || d.last_status === 'ONLINE').length}
//             </p>
//           </div>
//           <div className="p-3 border md:p-4 bg-richblue-600/20 border-blue-700/80 rounded-xl">
//             <p className="text-xs text-blue-300 md:text-sm">Inactive</p>
//             <p className="mt-1 text-xl font-bold text-blue-200 md:text-2xl">
//               {devices.filter(d => d.last_status === 'OFFLINE').length}
//             </p>
//           </div>
//           <div className="p-3 border md:p-4 bg-richblue-600/20 border-blue-700/80 rounded-xl">
//             <p className="text-xs text-blue-300 md:text-sm">Total Users</p>
//             <p className="mt-1 text-xl font-bold text-white md:text-2xl">
//               {devices.reduce((acc, d) => acc + (d.users_count || 0), 0)}
//             </p>
//           </div>
//         </div>

//         {/* Search + Filter */}
//         <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
//           <div className="relative flex-1">
//             <input
//               type="text"
//               placeholder="Search by name, code, location..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full py-2 pr-4 text-sm text-white border rounded-lg pl-9 bg-richblue-600/20 border-blue-700/80 placeholder-blue-400/40 focus:outline-none focus:ring-2 focus:ring-blue-700"
//             />
//             <svg className="absolute left-2.5 top-2.5 h-4 w-4 text-blue-400/60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </div>
//           <select
//             value={filterStatus}
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="px-3 py-2 text-sm text-white border rounded-lg bg-richblue-600/20 border-blue-700/80 focus:outline-none focus:ring-2 focus:ring-blue-700 sm:w-36"
//           >
//             <option value="all">All Status</option>
//             <option value="ONLINE">Online</option>
//             <option value="OFFLINE">Offline</option>
//           </select>
//           <div className="flex items-center justify-center px-3 py-2 text-xs text-blue-300 border rounded-lg bg-blue-600/20 border-blue-700/80 sm:whitespace-nowrap">
//             {filteredDevices.length} {filteredDevices.length === 1 ? 'device' : 'devices'} found
//           </div>
//         </div>
//       </div>

//       {/* ── BULK ACTION BAR ── */}
//       {someSelected && (role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//         <div className="flex items-center justify-between gap-3 px-3 py-2.5 mx-3 sm:mx-4 mb-2 rounded-xl border border-red-700/50 bg-red-900/20">
//           <div className="flex items-center gap-2 text-sm text-red-300">
//             <CheckIcon className="w-4 h-4" />
//             <span className="font-medium">{selectedIds.size} device{selectedIds.size > 1 ? 's' : ''} selected</span>
//           </div>
//           <div className="flex items-center gap-2">
//             <button onClick={clearSelection} className="px-3 py-1.5 text-xs text-blue-100 border rounded-lg border-blue-400/80 hover:bg-blue-800/30 transition-colors">
//               Clear
//             </button>
//             <button
//               onClick={() => setIsBulkDeleteOpen(true)}
//               className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors"
//             >
//               <Trash2 className="w-3.5 h-3.5" /> Delete Selected
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ── MOBILE: Card List ── */}
//       <div className="flex flex-col flex-1 gap-3 px-3 pb-4 overflow-y-auto md:hidden">
//         {filteredDevices.length > 0 && (role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//           <div className="flex items-center justify-between px-1">
//             <label className="flex items-center gap-2 text-xs text-blue-300 cursor-pointer select-none" onClick={toggleSelectAll}>
//               <input
//                 type="checkbox"
//                 checked={allFilteredSelected}
//                 onChange={toggleSelectAll}
//                 className="w-4 h-4 text-red-500 border-blue-700 rounded bg-richblue-900 focus:ring-red-600/50"
//               />
//               Select all ({filteredDevices.length})
//             </label>
//           </div>
//         )}

//         {filteredDevices.length > 0 ? (
//           filteredDevices.map(device => (
//             <DeviceCard
//               key={device._id}
//               device={device}
//               isSelected={selectedIds.has(device._id)}
//               onSelect={toggleSelectDevice}
//             />
//           ))
//         ) : (
//           <div className="flex flex-col items-center justify-center py-16 text-blue-400/50">
//             <Power className="w-10 h-10 mb-3" />
//             <p className="text-sm">No devices found matching your criteria</p>
//           </div>
//         )}
//       </div>

//       {/* ── DESKTOP: Table ── */}
//       <div className="flex-1 hidden px-4 pb-4 md:block">
//         <div className="border shadow-xl bg-richblue-800/20 border-blue-700/80 rounded-xl shadow-blue-800/60">
//           <div className="overflow-y-auto overflow-x-auto max-h-[500px] rounded-xl">
//             <table className="w-full text-left border-collapse">
//               <thead className="sticky top-0 z-10 bg-richblue-950">
//                 <tr className="border-b border-blue-800/60">
//                   {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//                     <th className="w-10 p-3">
//                       <input
//                         type="checkbox"
//                         checked={allFilteredSelected}
//                         onChange={toggleSelectAll}
//                         className="w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//                       />
//                     </th>
//                   )}
//                   <th className="w-10 p-1"></th>
//                   <th className="p-3 pl-0 font-semibold text-blue-300">Device Name</th>
//                   <th className="p-3 font-semibold text-blue-300">Device Code</th>
//                   <th className="p-3 font-semibold text-blue-300">Location</th>
//                   <th className="p-3 font-semibold text-blue-300">Firmware</th>
//                   {role === ACCOUNT_TYPE.ORGANIZATION && (
//                     <th className="p-3 font-semibold text-blue-300">Manager</th>
//                   )}
//                   <th className="p-3 font-semibold text-blue-300">Users</th>
//                   <th className="p-3 font-semibold text-blue-300">Status</th>
//                   <th className="p-3 font-semibold text-blue-300">Last Seen</th>
//                   {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//                     <th className="p-3 font-semibold text-blue-300">Actions</th>
//                   )}
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-blue-900/50">
//                 {filteredDevices.length > 0 ? (
//                   filteredDevices.map((device) => {
//                     const isSelected = selectedIds.has(device._id);
//                     return (
//                       <React.Fragment key={device._id}>
//                         <tr
//                           className={`transition-colors cursor-pointer hover:bg-blue-950/30 ${isSelected ? 'bg-red-900/10' : ''}`}
//                           onClick={() => handleDeviceClick(device)}
//                         >
//                           {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//                             <td className="p-3" onClick={(e) => e.stopPropagation()}>
//                               <input
//                                 type="checkbox"
//                                 checked={isSelected}
//                                 onChange={(e) => toggleSelectDevice(e, device._id)}
//                                 className="w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//                               />
//                             </td>
//                           )}
//                           <td
//                             className="w-10 p-1"
//                             onClick={(e) => { e.stopPropagation(); toggleDeviceRow(device._id); }}
//                           >
//                             <button
//                               className="flex items-center justify-center p-1 text-blue-400 transition-colors rounded hover:bg-blue-800/30"
//                               title="View device status history"
//                             >
//                               {expandedDeviceRows[device._id]
//                                 ? <ChevronUp className="w-4 h-4" />
//                                 : <ChevronDown className="w-4 h-4" />}
//                             </button>
//                           </td>
//                           <td className="p-3 pl-0">
//                             <div className="flex items-center gap-3">
//                               <div className="flex items-center justify-center w-10 h-10 font-bold text-white border rounded-full bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//                                 {device.device_name?.charAt(0) || 'D'}
//                               </div>
//                               <span className="font-medium text-white">{device.device_name}</span>
//                             </div>
//                           </td>
//                           <td className="p-3 font-mono text-sm text-blue-300/80">{device.device_code}</td>
//                           <td className="p-3 text-gray-400">{device.device_location}</td>
//                           <td className="p-3 text-white">{device.device_firmware_version}</td>
//                           {role === ACCOUNT_TYPE.ORGANIZATION && (
//                             <td className="p-3 text-blue-400">{device.device_manager_id?.manager_name || 'N/A'}</td>
//                           )}
//                           <td className="p-3">
//                             <span className="px-2 py-1 text-xs text-blue-300 rounded-lg bg-blue-600/20">
//                               {device.users_count || 0} user(s)
//                             </span>
//                           </td>
//                           <td className="p-3">
//                             <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getLastStatusBadge(device.last_status)}`}>
//                               {device.last_status}
//                             </span>
//                           </td>
//                           <td className="p-3 text-sm text-gray-400">{formatDate(device.device_last_seen)}</td>
//                           {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
//                             <td className="p-3">
//                               <div className="flex items-center gap-2">
//                                 <button
//                                   onClick={(e) => handleEditClick(e, device)}
//                                   className="p-2 text-blue-400 transition-colors rounded-lg bg-blue-600/20 hover:bg-blue-600/30"
//                                   title="Edit Device"
//                                 >
//                                   <Edit2 className="w-4 h-4" />
//                                 </button>
//                                 <button
//                                   onClick={(e) => handleDeleteClick(e, device)}
//                                   className="p-2 text-red-400 transition-colors rounded-lg bg-red-600/20 hover:bg-red-600/30"
//                                   title="Delete Device"
//                                 >
//                                   <Trash2 className="w-4 h-4" />
//                                 </button>
//                               </div>
//                             </td>
//                           )}
//                         </tr>

//                         {/* Expanded Device Status History Row */}
//                         {expandedDeviceRows[device._id] && (
//                           <tr className="border-t bg-white/5 border-blue-500/20">
//                             <td colSpan={totalCols} className="px-6 py-4">
//                               <StatusHistoryPanel device={device} />
//                             </td>
//                           </tr>
//                         )}
//                       </React.Fragment>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={totalCols} className="p-8 text-center text-blue-400/60">
//                       No devices found matching your criteria
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* ── BULK DELETE MODAL ── */}
//       {isBulkDeleteOpen && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 bg-black/60 backdrop-blur-sm" onClick={() => !isBulkDeleting && setIsBulkDeleteOpen(false)}>
//           <div className="w-full border sm:max-w-md bg-richblue-950 border-red-700/50 rounded-2xl sm:mb-0 mb-[200px]" onClick={(e) => e.stopPropagation()}>
//             <div className="flex justify-center pt-3 pb-1 sm:hidden">
//               <div className="w-10 h-1 bg-gray-600 rounded-full" />
//             </div>
//             <div className="p-5 space-y-4 sm:p-6">
//               <div className="flex items-start gap-3">
//                 <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-red-600/20">
//                   <Trash2 className="w-5 h-5 text-red-400" />
//                 </div>
//                 <div>
//                   <h3 className="text-base font-bold text-white">Delete {selectedIds.size} Device{selectedIds.size > 1 ? 's' : ''}?</h3>
//                   <p className="mt-1 text-sm text-gray-400">
//                     This will permanently delete {selectedIds.size === 1 ? 'the selected device' : `all ${selectedIds.size} selected devices`}. This action cannot be undone.
//                   </p>
//                 </div>
//               </div>

//               <div className="p-3 space-y-1 overflow-y-auto border rounded-lg max-h-32 border-red-800/30 bg-red-900/10">
//                 {[...selectedIds].map(id => {
//                   const d = devices.find(d => d._id === id);
//                   return d ? (
//                     <div key={id} className="flex items-center gap-2 text-sm">
//                       <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-[10px] font-bold text-white">
//                         {d.device_name?.charAt(0)}
//                       </div>
//                       <span className="text-white truncate">{d.device_name}</span>
//                       <span className="flex-shrink-0 ml-auto text-xs text-blue-400/50">{d.device_code}</span>
//                     </div>
//                   ) : null;
//                 })}
//               </div>

//               {isBulkDeleting && (
//                 <div className="space-y-2">
//                   <div className="flex justify-between text-xs text-blue-300">
//                     <span>Deleting devices...</span>
//                     <span>{bulkProgress.current} / {bulkProgress.total}</span>
//                   </div>
//                   <div className="w-full h-2 rounded-full bg-richblue-900">
//                     <div
//                       className="h-2 transition-all duration-300 bg-red-600 rounded-full"
//                       style={{ width: `${bulkProgress.total > 0 ? (bulkProgress.current / bulkProgress.total) * 100 : 0}%` }}
//                     />
//                   </div>
//                 </div>
//               )}

//               <div className="flex gap-3 pb-2 sm:pb-0">
//                 <button
//                   type="button"
//                   onClick={() => setIsBulkDeleteOpen(false)}
//                   disabled={isBulkDeleting}
//                   className="flex-1 py-2.5 text-sm font-medium text-blue-300 border rounded-lg border-blue-800/60 hover:bg-blue-800/20 transition-colors disabled:opacity-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   onClick={handleBulkDeleteConfirm}
//                   disabled={isBulkDeleting}
//                   className="flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   {isBulkDeleting
//                     ? <><Loader2 className="w-4 h-4 animate-spin" /> Deleting...</>
//                     : <><Trash2 className="w-4 h-4" /> Delete {selectedIds.size} Device{selectedIds.size > 1 ? 's' : ''}</>
//                   }
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── CREATE / EDIT MODAL ── */}
//       {isFormModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/60 backdrop-blur-sm" onClick={closeModals}>
//           <div
//             className="w-full sm:max-w-md border bg-richblue-950 border-blue-700/50 rounded-2xl max-h-[90vh] overflow-y-auto sm:mb-0 mb-[50px]"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="sticky top-0 z-10 flex items-center justify-between p-4 border-b md:p-6 border-blue-800/40 bg-richblue-950">
//               <h2 className="text-lg font-bold text-white md:text-xl">
//                 {formMode === 'create' ? 'Add New Device' : 'Edit Device'}
//               </h2>
//               <button onClick={closeModals} className="p-2 transition-colors rounded-lg hover:bg-blue-600/20">
//                 <X className="w-5 h-5 text-blue-400" />
//               </button>
//             </div>
//             <form onSubmit={handleFormSubmit} className="p-4 space-y-4 md:p-6">
//               {[
//                 { name: 'device_name', label: 'Device Name', icon: Power, readOnly: false },
//                 { name: 'device_code', label: 'Device Code', icon: Code, readOnly: formMode !== 'create' },
//                 { name: 'secret_key', label: 'Secret Key', icon: Key, readOnly: formMode !== 'create' },
//                 { name: 'device_location', label: 'Location', icon: MapPin, readOnly: false },
//                 { name: 'device_firmware_version', label: 'Firmware Version', icon: Cpu, readOnly: false },
//               ].map(({ name, label, icon: Icon, readOnly }) => (
//                 <div key={name}>
//                   <label className="block mb-1.5 text-sm font-medium text-blue-200">
//                     <Icon className="inline w-4 h-4 mr-1 text-blue-400" />
//                     {label} *
//                   </label>
//                   <input
//                     type="text"
//                     name={name}
//                     value={formData[name]}
//                     onChange={handleInputChange}
//                     readOnly={readOnly}
//                     className={`w-full px-4 py-2.5 bg-richblue-900 border ${formErrors[name] ? 'border-red-500/50' : 'border-blue-800/60'} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 text-white placeholder-blue-400/40 text-sm ${readOnly ? 'opacity-60 cursor-not-allowed' : ''}`}
//                     placeholder={`Enter ${label.toLowerCase()}`}
//                   />
//                   {formErrors[name] && <p className="mt-1 text-xs text-red-400">{formErrors[name]}</p>}
//                 </div>
//               ))}

//               {role === ACCOUNT_TYPE.ORGANIZATION && (
//                 <div>
//                   <label className="block mb-1.5 text-sm font-medium text-blue-300">
//                     <User className="inline w-4 h-4 mr-1 text-blue-400" />
//                     Manager *
//                   </label>
//                   <select
//                     name="managerId"
//                     value={formData.managerId}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full px-4 py-2.5 text-sm text-white border rounded-lg bg-richblue-900 border-blue-800/60 focus:outline-none focus:ring-2 focus:ring-blue-700"
//                   >
//                     <option value="">Select Manager</option>
//                     {managersList.map(manager => (
//                       <option key={manager._id} value={manager._id}>
//                         {manager.manager_name} ({manager.manager_email})
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               )}

//               <div className="flex gap-3 pt-2">
//                 <button type="button" onClick={closeModals} className="flex-1 px-4 py-2.5 border border-blue-800/60 hover:bg-blue-600/10 text-blue-300 text-sm font-medium rounded-lg transition-colors">
//                   Cancel
//                 </button>
//                 <button type="submit" disabled={formLoading} className="flex-1 px-4 py-2.5 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
//                   {formLoading ? (
//                     <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Saving...</>
//                   ) : (
//                     <><Save className="w-4 h-4" />{formMode === 'create' ? 'Create' : 'Update'}</>
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ── DELETE DEVICE MODAL ── */}
//       {isDeleteModalOpen && deviceToDelete && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/60 backdrop-blur-sm" onClick={closeModals}>
//           <div className="w-full border sm:max-w-md bg-richblue-950 border-red-700/50 rounded-2xl sm:mb-0 mb-[200px]" onClick={(e) => e.stopPropagation()}>
//             <div className="p-6 text-center">
//               <div className="flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 md:w-16 md:h-16 bg-red-600/20">
//                 <AlertTriangle className="text-red-400 w-7 h-7 md:w-8 md:h-8" />
//               </div>
//               <h2 className="mb-2 text-lg font-bold text-white md:text-xl">Delete Device</h2>
//               <p className="mb-6 text-sm text-blue-200/70">
//                 Are you sure you want to delete "<span className="font-medium text-white">{deviceToDelete.device_name}</span>"? This action cannot be undone.
//               </p>
//               <div className="flex gap-3">
//                 <button onClick={closeModals} className="flex-1 px-4 py-2.5 border border-blue-800/60 hover:bg-blue-600/10 text-blue-300 text-sm font-medium rounded-lg transition-colors">Cancel</button>
//                 <button onClick={handleDeleteConfirm} disabled={formLoading} className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
//                   {formLoading ? <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Deleting...</> : <><Trash2 className="w-4 h-4" /> Delete</>}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── UNENROLL MODAL ── */}
//       {isUnenrollModalOpen && deviceToUnenroll && (
//         <div className="fixed inset-0 flex items-end sm:items-center justify-center z-[60] p-0 sm:p-4 bg-black/60 backdrop-blur-sm" onClick={closeModals}>
//           <div className="w-full border sm:max-w-md bg-richblue-950 border-yellow-700/50 rounded-t-2xl sm:rounded-2xl" onClick={(e) => e.stopPropagation()}>
//             <div className="p-6 text-center">
//               <div className="flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 bg-yellow-600/20">
//                 <AlertTriangle className="text-yellow-400 w-7 h-7" />
//               </div>
//               <h2 className="mb-2 text-lg font-bold text-white md:text-xl">Unenroll All Users</h2>
//               <p className="mb-3 text-sm text-blue-200/70">Are you sure you want to unenroll all users from "<span className="font-medium text-white">{deviceToUnenroll.device_name}</span>"?</p>
//               <p className="mb-6 text-xs text-yellow-400/80">This will remove all enrolled fingerprints from this device. Users will need to enroll again.</p>
//               <div className="flex gap-3">
//                 <button onClick={closeModals} className="flex-1 px-4 py-2.5 border border-blue-800/60 hover:bg-blue-600/10 text-blue-300 text-sm font-medium rounded-lg transition-colors">Cancel</button>
//                 <button onClick={handleUnenrollConfirm} disabled={formLoading} className="flex-1 px-4 py-2.5 bg-yellow-600 hover:bg-yellow-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
//                   {formLoading ? <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Unenrolling...</> : <><Users className="w-4 h-4" /> Unenroll All</>}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── DELETE USERS MODAL ── */}
//       {isDeleteUserModalOpen && deleteUserFromDevice && (
//         <div className="fixed inset-0 flex items-end sm:items-center justify-center z-[60] p-0 sm:p-4 bg-black/60 backdrop-blur-sm" onClick={closeModals}>
//           <div className="w-full border sm:max-w-md bg-richblue-950 border-yellow-700/50 rounded-t-2xl sm:rounded-2xl" onClick={(e) => e.stopPropagation()}>
//             <div className="p-6 text-center">
//               <div className="flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 bg-yellow-600/20">
//                 <AlertTriangle className="text-yellow-400 w-7 h-7" />
//               </div>
//               <h2 className="mb-2 text-lg font-bold text-white md:text-xl">Delete All Users</h2>
//               <p className="mb-3 text-sm text-blue-200/70">Are you sure you want to delete all users from "<span className="font-medium text-white">{deleteUserFromDevice.device_name}</span>"?</p>
//               <p className="mb-6 text-xs text-yellow-400/80">This will remove all users from this device. Users will need to create and enroll again.</p>
//               <div className="flex gap-3">
//                 <button onClick={closeModals} className="flex-1 px-4 py-2.5 border border-blue-800/60 hover:bg-blue-600/10 text-blue-300 text-sm font-medium rounded-lg transition-colors">Cancel</button>
//                 <button onClick={handleDeleteUsers} disabled={formLoading} className="flex-1 px-4 py-2.5 bg-yellow-600 hover:bg-yellow-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
//                   {formLoading ? <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Deleting...</> : <><Users className="w-4 h-4" /> Delete All</>}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── VIEW DEVICE MODAL ── */}
//       {isModalOpen && selectedDevice && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/60 backdrop-blur-sm" onClick={closeModals}>
//           <div
//             className="bg-richblue-950 border border-blue-700/50 rounded-t-2xl sm:rounded-2xl w-full sm:max-w-4xl max-h-[90vh] sm:max-h-[80vh] overflow-y-auto"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="sticky top-0 z-10 flex items-center justify-between p-4 border-b md:p-6 bg-richblue-950/95 backdrop-blur-sm border-blue-800/40">
//               <h2 className="flex items-center gap-2 text-lg font-bold text-white md:text-2xl">
//                 <Power className="w-5 h-5 text-blue-500 md:w-6 md:h-6" />
//                 Device Details
//               </h2>
//               <button onClick={closeModals} className="p-2 transition-colors rounded-lg hover:bg-blue-600/20">
//                 <X className="w-5 h-5 text-blue-400 md:w-6 md:h-6" />
//               </button>
//             </div>

//             <div className="p-4 space-y-4 md:p-6 md:space-y-6">
//               <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
//                 <div className="p-4 border bg-richblue-950 rounded-xl border-blue-800/40">
//                   <h3 className="flex items-center gap-2 mb-3 text-sm font-semibold text-blue-300 md:text-base">
//                     <Power className="w-4 h-4" /> Basic Information
//                   </h3>
//                   <div className="space-y-2 text-sm">
//                     {[
//                       ['Device Name', selectedDevice.device_name, 'text-white font-medium'],
//                       ['Device Code', selectedDevice.device_code, 'font-mono text-gray-300'],
//                       ['Secret Key', selectedDevice.secret_key, 'font-mono text-gray-400'],
//                       ['Location', selectedDevice.device_location, 'text-white'],
//                       ['Firmware', selectedDevice.device_firmware_version, 'text-white'],
//                       ['Manager', selectedDevice.device_manager_id?.manager_name || 'N/A', 'text-white'],
//                     ].map(([label, val, cls]) => (
//                       <div key={label} className="flex justify-between gap-2">
//                         <span className="flex-shrink-0 text-blue-400">{label}</span>
//                         <span className={`${cls} text-right break-all`}>{val}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="p-4 border bg-richblue-950 rounded-xl border-blue-800/40">
//                   <h3 className="flex items-center gap-2 mb-3 text-sm font-semibold text-blue-300 md:text-base">
//                     <Wifi className="w-4 h-4" /> Status Information
//                   </h3>
//                   <div className="space-y-2 text-sm">
//                     <div className="flex justify-between">
//                       <span className="text-blue-400">Device Status</span>
//                       <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusBadge(selectedDevice.last_status)}`}>
//                         {selectedDevice.last_status === 'ONLINE' || selectedDevice.last_status === 'HEARTBEAT' ? 'ACTIVE' : 'INACTIVE'}
//                       </span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span className="text-blue-400">Last Status</span>
//                       <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getLastStatusBadge(selectedDevice.last_status)}`}>
//                         {selectedDevice.last_status}
//                       </span>
//                     </div>
//                     <div className="flex justify-between gap-2">
//                       <span className="flex-shrink-0 text-blue-400">Last Seen</span>
//                       <span className="text-right text-gray-400">{formatDate(selectedDevice.device_last_seen)}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span className="text-blue-400">Users Count</span>
//                       <span className="font-bold text-white">{selectedDevice.users_count || 0}</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="p-4 border bg-richblue-950 rounded-xl border-blue-800/40">
//                 <h3 className="flex items-center gap-2 mb-3 text-sm font-semibold text-blue-300 md:text-base">
//                   <Users className="w-4 h-4" /> References
//                 </h3>
//                 <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//                   <div>
//                     <p className="text-xs text-blue-400 mb-0.5">Organization</p>
//                     <p className="font-mono text-sm text-white break-all">{selectedDevice.org_id?.org_name || 'N/A'}</p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-blue-400 mb-0.5">Manager</p>
//                     <p className="font-mono text-sm text-white break-all">{selectedDevice.device_manager_id?.manager_name || 'N/A'}</p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-blue-400 mb-0.5">Version</p>
//                     <p className="text-sm text-white">v{selectedDevice.__v}</p>
//                   </div>
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
//                 <div className="p-4 border bg-richblue-950 rounded-xl border-blue-800/40">
//                   <h3 className="mb-2 text-sm font-semibold text-blue-300">Created</h3>
//                   <p className="text-xs text-gray-400">By: {selectedDevice.createdBy || 'N/A'}</p>
//                   <p className="text-xs text-gray-400">At: {formatDate(selectedDevice.createdAt)}</p>
//                 </div>
//                 <div className="p-4 border bg-richblue-950 rounded-xl border-blue-800/40">
//                   <h3 className="mb-2 text-sm font-semibold text-blue-300">Last Updated</h3>
//                   <p className="text-xs text-gray-400">By: {selectedDevice.updatedBy || 'N/A'}</p>
//                   <p className="text-xs text-gray-400">At: {formatDate(selectedDevice.updatedAt)}</p>
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
//                 <div
//                   onClick={() => handleUnenrollClick(selectedDevice)}
//                   className="p-4 transition-colors border cursor-pointer bg-richblue-950 rounded-xl border-yellow-600/40 hover:bg-yellow-900/20"
//                 >
//                   <h3 className="inline-block px-3 py-1 text-xs font-semibold text-yellow-400 border rounded-lg md:text-sm bg-yellow-900/30 border-yellow-500/40">
//                     Unenroll All Users
//                   </h3>
//                   <p className="mt-2 text-xs text-gray-400">
//                     This will remove all enrolled fingerprints from this device. Users will need to enroll again.
//                   </p>
//                 </div>
//                 <div
//                   onClick={() => handleDeleteUserClick(selectedDevice)}
//                   className="p-4 transition-colors border cursor-pointer bg-richblue-950 rounded-xl border-yellow-600/40 hover:bg-yellow-900/20"
//                 >
//                   <h3 className="inline-block px-3 py-1 text-xs font-semibold text-yellow-400 border rounded-lg md:text-sm bg-yellow-900/30 border-yellow-500/40">
//                     Delete All Users
//                   </h3>
//                   <p className="mt-2 text-xs text-gray-400">
//                     This will remove all users from this device. Users will need to create and enroll again.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DeviceManagement;

import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Plus, Edit2, Trash2, X, Save, AlertTriangle,
  Power, Wifi, MapPin, Code, Key, Cpu, Users, User,
  ChevronDown, ChevronUp, History, Activity, XCircle,
  Check as CheckIcon, Loader2
} from 'lucide-react';
import StandardSpinner from '../../../utils/Spinner';
import useSocket from '../../../hooks/useSocket';
import { ACCOUNT_TYPE } from '../../../utils/Account_Type';
import {
  Get_Devices,
  Create_Devices,
  Update_Devices,
  Delete_Devices,
  Unenroll_Users_From_device,
  Delete_Users_From_device,
  Get_Org_Devices,
  Create_Org_Device,
  Update_Org_Device,
  Delete_Org_Device,
  Get_Device_History
} from '../../../services/oprations/Device';
import { useToast } from '../../Toast';
import { useTheme } from '../../../Context/themeContext';

const DeviceManagement = () => {
  const toast = useToast();
  const { theme } = useTheme();
  //const [text, setText] = useState("")
  const [selectedDevice, setSelectedDevice] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isUnenrollModalOpen, setIsUnenrollModalOpen] = useState(false);
  const [isDeleteUserModalOpen, setIsDeleteUserModalOpen] = useState(false);
  const [deleteUserFromDevice, setDeleteUserFromDevice] = useState(null);
  const [deviceToDelete, setDeviceToDelete] = useState(null);
  const [deviceToUnenroll, setDeviceToUnenroll] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formLoading, setFormLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [formMode, setFormMode] = useState('create');
  const [formData, setFormData] = useState({
    device_name: '',
    device_code: '',
    secret_key: '',
    device_location: '',
    device_firmware_version: '',
    managerId: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [expandedDeviceRows, setExpandedDeviceRows] = useState({});

  // ── Device history state ──────────────────────────────────────────────
  const [deviceHistoryMap, setDeviceHistoryMap] = useState({});
  const [loadingHistoryMap, setLoadingHistoryMap] = useState({});

  // ── Multi-select / bulk delete ──────────────────────────────────────────
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  const [bulkProgress, setBulkProgress] = useState({ current: 0, total: 0 });

  const { devices } = useSelector((state) => state.device);
  const { token } = useSelector((state) => state.auth);
  const { managers } = useSelector((state) => state.manager);
  const { user } = useSelector((state) => state.profile);
  const userData = typeof user === 'string' ? JSON.parse(user) : user;

  const role = userData?.role;
  const managersList = typeof managers === 'string' ? JSON.parse(managers) : (managers || []);

  const deviceData = typeof devices === 'string' ? JSON.parse(devices) : (devices || []);
  console.log("deviceData...", deviceData);

  const dispatch = useDispatch();
  const socket = useSocket(); 

  // Theme-aware color classes
  const isDark = theme === 'dark';
  
  //const bgPrimary = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  //const bgSecondary = isDark ? 'bg-richblue-800/20' : 'bg-gray-100/50';
  //const bgCard = isDark ? 'bg-richblue-950' : 'bg-white';
  //const bgHover = isDark ? 'hover:bg-blue-950/30' : 'hover:bg-gray-100/50';
  //const borderColor = isDark ? 'border-blue-700/80' : 'border-gray-300';
  //const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  //const borderLighter = isDark ? 'border-blue-700/60' : 'border-gray-300';
  //const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-gray-400' : 'text-gray-600';
  //const textBlue = isDark ? 'text-blue-300' : 'text-blue-700';
  //const textBlueLight = isDark ? 'text-blue-400/70' : 'text-blue-600/70';
  //const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  const inputBg = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  const inputBorder = isDark ? 'border-blue-800/60' : 'border-gray-300';
  //const placeholderColor = isDark ? 'placeholder-blue-400/40' : 'placeholder-gray-400';
  const modalBg = isDark ? 'bg-richblue-950' : 'bg-white';
  //const modalBorder = isDark ? 'border-blue-700/50' : 'border-gray-300';



  const fetchDevices = useCallback(() => {
    if (role === ACCOUNT_TYPE.ORGANIZATION) {
      dispatch(Get_Org_Devices(token));
    } else if (role === ACCOUNT_TYPE.MANAGER) {
      dispatch(Get_Devices(token));
    } else {
      dispatch(Get_Org_Devices(token));
    }
  },[dispatch, role, token]);

  useEffect(() => { fetchDevices(); }, [dispatch, token, role, fetchDevices]);

  // ── Fetch device history ───────────────────────────────────────────────
  const fetchDeviceHistory = async (deviceId) => {
    if (loadingHistoryMap[deviceId]) return;

    setLoadingHistoryMap(prev => ({ ...prev, [deviceId]: true }));

    try {
      console.log("Fetching history for deviceId:", deviceId);
      const res = await dispatch(Get_Device_History(deviceId));
      console.log("Full raw response:", JSON.stringify(res, null, 2));

      const rawData = res?.data?.data;
      console.log("rawData:", rawData);
      console.log("rawData length:", rawData?.length);

      if (res?.data?.success && Array.isArray(rawData) && rawData.length > 0) {
        const historyData = rawData.map(entry => {
          console.log("Entry fields:", Object.keys(entry), entry);
          return {
            _id:        entry._id,
            status:     entry.status,
            lastseenAt: entry.lastseenAt,
            deviceName: entry.deviceName,
            deviceId:   entry.deviceId,
            managerId:  entry.managerId,
            orgId:      entry.orgId,
          };
        });
        setDeviceHistoryMap(prev => ({ ...prev, [deviceId]: historyData }));
      } else {
        console.warn("No data or success=false. res.data:", res?.data);
        setDeviceHistoryMap(prev => ({ ...prev, [deviceId]: [] }));
      }
    } catch (error) {
      console.error("Error:", error);
      setDeviceHistoryMap(prev => ({ ...prev, [deviceId]: [] }));
    } finally {
      setLoadingHistoryMap(prev => ({ ...prev, [deviceId]: false }));
    }
  };

  // Toggle row expansion and lazy-load history
  const toggleDeviceRow = async (id) => {
    const isExpanding = !expandedDeviceRows[id];
    setExpandedDeviceRows(prev => ({ ...prev, [id]: isExpanding }));
    if (isExpanding && !deviceHistoryMap[id] && !loadingHistoryMap[id]) {
      await fetchDeviceHistory(id);
    }
  };

  useEffect(() => {
    if (!socket) return;
    socket.on("Device_Status", () => { fetchDevices(); });
    return () => { socket.off("Device_Status"); };
  }, [socket, dispatch, token, role, fetchDevices]);

  useEffect(() => {
    setTimeout(() => { setLoading(false); }, 800);
  }, []);

  // ── Selection helpers ───────────────────────────────────────────────────
  const filteredDevices = devices.filter(device => {
    const matchesSearch =
      device.device_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.device_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.device_location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.device_firmware_version?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (device.device_manager_id?.manager_name?.toLowerCase() || '').includes(searchTerm.toLowerCase());

    const matchesStatus =
      filterStatus === 'all' ||
      (filterStatus === 'ONLINE' && (device.last_status === 'ONLINE' || device.last_status === 'HEARTBEAT')) ||
      (filterStatus === 'OFFLINE' && device.last_status === 'OFFLINE');

    return matchesSearch && matchesStatus;
  });

  const allFilteredSelected = filteredDevices.length > 0 && filteredDevices.every(d => selectedIds.has(d._id));
  const someSelected = selectedIds.size > 0;

  const toggleSelectAll = () => {
    if (allFilteredSelected) {
      setSelectedIds(prev => {
        const next = new Set(prev);
        filteredDevices.forEach(d => next.delete(d._id));
        return next;
      });
    } else {
      setSelectedIds(prev => {
        const next = new Set(prev);
        filteredDevices.forEach(d => next.add(d._id));
        return next;
      });
    }
  };

  const toggleSelectDevice = (e, deviceId) => {
    e.stopPropagation();
    setSelectedIds(prev => {
      const next = new Set(prev);
      next.has(deviceId) ? next.delete(deviceId) : next.add(deviceId);
      return next;
    });
  };

  const clearSelection = () => setSelectedIds(new Set());

  // ── Bulk delete ─────────────────────────────────────────────────────────
  const handleBulkDeleteConfirm = async () => {
    const ids = [...selectedIds];
    setIsBulkDeleting(true);
    setBulkProgress({ current: 0, total: ids.length });

    let successCount = 0;
    let errorCount = 0;

    for (let i = 0; i < ids.length; i++) {
      setBulkProgress({ current: i + 1, total: ids.length });
      try {
        const res = role === ACCOUNT_TYPE.ORGANIZATION
          ? await dispatch(Delete_Org_Device(ids[i]))
          : await dispatch(Delete_Devices(ids[i]));
        if (res?.data?.success) successCount++;
        else errorCount++;
      } catch {
        errorCount++;
      }
    }

    if (successCount > 0) toast.success(`Deleted ${successCount} device${successCount > 1 ? 's' : ''}${errorCount > 0 ? `, ${errorCount} failed` : ''} successfully`);
    if (errorCount > 0 && successCount === 0) toast.error(`Failed to delete ${errorCount} device${errorCount > 1 ? 's' : ''}`);

    await fetchDevices();
    setIsBulkDeleting(false);
    setIsBulkDeleteOpen(false);
    setBulkProgress({ current: 0, total: 0 });
    clearSelection();
  };

  // ── Duration helper using lastseenAt ────────────────────────────────────
  // eslint-disable-next-line
  const formatDuration = (startTime, endTime) => {
    if (!startTime) return '';
    
    const diffMs = (endTime ? new Date(endTime) : new Date()) - new Date(startTime);
    if (diffMs < 0) return '';

    const hours = Math.floor(diffMs / 3600000);
    const minutes = Math.floor((diffMs % 3600000) / 60000);
    const seconds = Math.floor((diffMs % 60000) / 1000);

    return `${hours ? `${hours}h ` : ''}${minutes}m ${seconds}s`;
  };

  const handleDeviceClick = (device) => { setSelectedDevice(device); setIsModalOpen(true); };

  const handleEditClick = (e, device) => {
    e.stopPropagation();
    setFormMode('edit');
    setFormData({
      device_name: device.device_name || '',
      device_code: device.device_code || '',
      secret_key: device.secret_key || '',
      device_location: device.device_location || '',
      device_firmware_version: device.device_firmware_version || '',
      managerId: device.device_manager_id?._id || device.device_manager_id || '',
      _id: device._id
    });
    setIsFormModalOpen(true);
  };

  const handleDeleteClick = (e, device) => {
    e.stopPropagation();
    setDeviceToDelete(device);
    setIsDeleteModalOpen(true);
  };

  const handleAddClick = () => {
    setFormMode('create');
    setFormData({ device_name: '', device_code: '', secret_key: '', device_location: '', device_firmware_version: '', managerId: '' });
    setFormErrors({});
    setIsFormModalOpen(true);
  };

  const handleUnenrollClick = (device) => { setDeviceToUnenroll(device); setIsUnenrollModalOpen(true); };
  const handleDeleteUserClick = (device) => { setDeleteUserFromDevice(device); setIsDeleteUserModalOpen(true); };

  const validateForm = () => {
    const errors = {};
    if (!formData.device_name.trim()) errors.device_name = 'Device name is required';
    if (!formData.device_code.trim()) errors.device_code = 'Device code is required';
    if (!formData.secret_key.trim()) errors.secret_key = 'Secret key is required';
    if (!formData.device_location.trim()) errors.device_location = 'Location is required';
    if (!formData.device_firmware_version.trim()) errors.device_firmware_version = 'Firmware version is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setFormLoading(true);
    try {
      let res;
      if (role === ACCOUNT_TYPE.ORGANIZATION) {
        res = formMode === 'create' ? await dispatch(Create_Org_Device(formData)) : await dispatch(Update_Org_Device(formData._id, formData));
      } else {
        res = formMode === 'create' ? await dispatch(Create_Devices(formData)) : await dispatch(Update_Devices(formData));
      }
      setIsFormModalOpen(false);
      setFormData({ device_name: '', device_code: '', secret_key: '', device_location: '', device_firmware_version: '', managerId: '' });
      if (res?.data?.success) { toast.success(res.data.message); fetchDevices(); }
      else toast.error(res?.data?.message || 'Error saving device');
    } catch (error) {
      toast.error('Error saving device');
    } finally { setFormLoading(false); }
  };

  const handleDeleteConfirm = async () => {
    if (!deviceToDelete) return;
    setFormLoading(true);
    try {
      const res = role === ACCOUNT_TYPE.ORGANIZATION
        ? await dispatch(Delete_Org_Device(deviceToDelete._id))
        : await dispatch(Delete_Devices(deviceToDelete._id));
      setIsDeleteModalOpen(false);
      setDeviceToDelete(null);
      if (res?.data?.success) { toast.success('Device deleted successfully'); fetchDevices(); }
      else toast.error(res?.data?.message || 'Error deleting device');
    } catch (error) {
      toast.error('Error deleting device');
    } finally { setFormLoading(false); }
  };

  const handleUnenrollConfirm = async () => {
    if (!deviceToUnenroll) return;
    setFormLoading(true);
    try {
      const res = await dispatch(Unenroll_Users_From_device(deviceToUnenroll._id));
      setIsUnenrollModalOpen(false);
      setDeviceToUnenroll(null);
      fetchDevices();
      if (res?.data?.success) toast.success(res.data.message);
      else toast.error(res?.data?.message || 'Error unenrolling users');
    } catch (error) {
      toast.error('Error unenrolling users');
    } finally { setFormLoading(false); }
  };

  const handleDeleteUsers = async () => {
    if (!deleteUserFromDevice) return;
    setFormLoading(true);
    try {
      const res = await dispatch(Delete_Users_From_device(deleteUserFromDevice._id));
      setIsDeleteUserModalOpen(false);
      setDeleteUserFromDevice(null);
      fetchDevices();
      if (res?.data?.success) toast.success(res.data.message);
      else toast.error(res?.data?.message || 'Error deleting users');
    } catch (error) {
      toast.error('Error deleting users');
    } finally { setFormLoading(false); }
  };

  const closeModals = () => {
    setIsModalOpen(false); setIsFormModalOpen(false); setIsDeleteModalOpen(false);
    setIsUnenrollModalOpen(false); setIsDeleteUserModalOpen(false);
    setDeviceToDelete(null); setDeviceToUnenroll(null); setDeleteUserFromDevice(null);
    setSelectedDevice(null); setFormErrors({});
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const getStatusBadge = (status) => {
   // const base = isDark ? 'border-opacity-50' : 'border-opacity-30';
    if (status === 'ONLINE' || status === 'HEARTBEAT') {
      return isDark 
        ? 'bg-green-900/50 text-green-300 border border-green-700/50'
        : 'bg-green-100 text-green-700 border border-green-600';
    }
    return isDark
      ? 'bg-red-900/50 text-red-300 border border-red-700/50'
      : 'bg-red-100 text-red-700 border border-red-300';
  };

  const getLastStatusBadge = (status) => {
   // const base = isDark ? 'border-opacity-50' : 'border-opacity-30';
    if (status === 'ONLINE' || status === 'HEARTBEAT') {
      return isDark
        ? 'bg-green-900/50 text-green-300 border border-green-700/50'
        : 'bg-green-100 text-green-700 border border-green-600';
    }
    return isDark
      ? 'bg-gray-900/50 text-gray-300 border border-gray-700/50'
      : 'bg-gray-100 text-gray-700 border border-gray-300';
  };

  const calculateDurationMs = (startTime, endTime) => {
    if (!startTime) return 0;
    const end = endTime ? new Date(endTime) : new Date();
    const start = new Date(startTime);
    return Math.max(0, end - start);
  };

  const formatDurationFromMs = (ms) => {
    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${hours ? `${hours}h ` : ''}${minutes}m ${seconds}s`;
  };

  const formatDateTimeHelper = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString([], { 
      day: '2-digit', 
      month: 'short', 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit' 
    });
  };

  // ── DEVICE STATUS HISTORY PANEL ────────────────────────────────────────────────
  const StatusHistoryPanel = ({ device }) => {
    const history = deviceHistoryMap[device._id];
    const isLoading = loadingHistoryMap[device._id];
    const [isRefreshing, setIsRefreshing] = useState(false);

    // Process history entries to calculate durations correctly
    const groupedHistory = React.useMemo(() => {
      if (!history || history.length === 0) return [];

      // Sort ascending (oldest → newest)
      const sorted = [...history].sort((a, b) => new Date(a.lastseenAt) - new Date(b.lastseenAt));

      // Calculate durations by pairing status entries with their next occurrence
      const calculatedDurations = [];
      
      for (let i = 0; i < sorted.length; i++) {
        const currentEntry = sorted[i];
        const nextEntry = sorted[i + 1];
        
        let endTime = null;
        
        // If there's a next entry, duration is until that entry
        if (nextEntry) {
          endTime = nextEntry.lastseenAt;
        }
        // Last entry - ongoing duration
        else {
          endTime = null; // null means ongoing/present
        }
        
        calculatedDurations.push({
          status: currentEntry.status,
          startTime: currentEntry.lastseenAt,
          endTime: endTime,
          rawEntry: currentEntry
        });
      }
      
      // Now group consecutive same-status entries and sum their durations
      const groups = [];
      let currentGroup = null;
      
      for (const entry of calculatedDurations) {
        if (!currentGroup || currentGroup.status !== entry.status) {
          // Start new group
          if (currentGroup) groups.push(currentGroup);
          currentGroup = {
            status: entry.status,
            startTime: entry.startTime,
            endTime: entry.endTime,
            durationMs: calculateDurationMs(entry.startTime, entry.endTime),
            entries: [entry]
          };
        } else {
          // Same status - extend the group
          currentGroup.endTime = entry.endTime;
          currentGroup.durationMs += calculateDurationMs(entry.startTime, entry.endTime);
          currentGroup.entries.push(entry);
        }
      }
      if (currentGroup) groups.push(currentGroup);
      
      // Convert to display format and reverse for most recent first
      return groups.reverse().map(group => ({
        ...group,
        duration: formatDurationFromMs(group.durationMs),
        startDisplay: formatDateTimeHelper(group.startTime),
        endDisplay: group.endTime === null ? 'Present' : formatDateTimeHelper(group.endTime),
        isPresent: group.endTime === null
      }));
    }, [history]);

    // Manual refresh function
    const handleRefreshHistory = async () => {
      if (isRefreshing || isLoading) return;
      setIsRefreshing(true);
      try {
        setDeviceHistoryMap(prev => ({ ...prev, [device._id]: undefined }));
        setLoadingHistoryMap(prev => ({ ...prev, [device._id]: true }));
        await fetchDeviceHistory(device._id);
        toast.success('History refreshed successfully');
      } catch (error) {
        console.error("Error refreshing history:", error);
        toast.error('Failed to refresh history');
      } finally {
        setIsRefreshing(false);
      }
    };

    const historyText = isDark ? 'text-blue-400/50' : 'text-gray-400';
    const historyBg = isDark ? 'bg-blue-800/40 text-blue-400/70' : 'bg-blue-100/20 text-blue-700';

    return (
      <div>
        <div className="flex items-center gap-2 mb-3">
          <History className={`flex-shrink-0 w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
          <h4 className={`text-sm font-medium ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>Device Status History</h4>
          {groupedHistory.length > 0 && (
            <span className={`text-xs px-2 py-0.5 rounded-full ${historyBg}`}>
              {groupedHistory.length} events · {history?.length || 0} records
            </span>
          )}
          
          {/* Refresh Button */}
          <button
            onClick={handleRefreshHistory}
            disabled={isRefreshing || isLoading}
            className={`ml-auto p-1.5 transition-colors rounded-lg ${isDark ? 'text-blue-400 hover:bg-blue-600/20' : 'text-blue-600 hover:bg-blue-100/20'} disabled:opacity-50 disabled:cursor-not-allowed`}
            title="Refresh history"
          >
            {isRefreshing ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            )}
          </button>
        </div>

        {(isLoading || isRefreshing) ? (
          <div className={`flex items-center justify-center py-6 ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
            <Loader2 className="w-5 h-5 animate-spin" />
            <span className={`ml-2 text-sm ${isDark ? 'text-blue-400/70' : 'text-blue-600/70'}`}>
              {isRefreshing ? 'Refreshing history...' : 'Loading history...'}
            </span>
          </div>

        ) : groupedHistory.length > 0 ? (
          <div className="flex flex-col gap-1.5 max-h-64 overflow-y-auto pr-1">
            {groupedHistory.map((group, idx) => {
              const isOnline = group.status === 'ONLINE' || group.status === 'HEARTBEAT';
              
              return (
                <div
                  key={idx}
                  className={`flex flex-wrap items-center gap-2 text-xs px-3 py-2 rounded-lg border ${
                    isOnline
                      ? isDark ? 'bg-green-500/5 border-green-500/15' : 'bg-green-50 border-green-200'
                      : isDark ? 'bg-gray-500/5 border-gray-500/15' : 'bg-gray-50 border-gray-200'
                  }`}
                >
                  {/* Icon */}
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 ${
                    isOnline 
                      ? isDark ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-600'
                      : isDark ? 'bg-gray-500/20 text-gray-400' : 'bg-gray-200 text-gray-600'
                  }`}>
                    {isOnline ? <Activity className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />}
                  </div>

                  {/* Status */}
                  <span className={`font-bold w-16 flex-shrink-0 ${
                    isOnline 
                      ? isDark ? 'text-green-400' : 'text-green-700'
                      : isDark ? 'text-gray-400' : 'text-gray-600'
                  }`}>
                    {group.status}
                  </span>

                  {/* Time range */}
                  <div className="flex flex-col min-w-0">
                    <span className={isDark ? 'text-blue-300/70' : 'text-gray-600'}>
                      {group.isPresent 
                        ? `${group.startDisplay} → Present`
                        : `${group.startDisplay} → ${group.endDisplay}`}
                    </span>
                    {group.entries.length > 1 && (
                      <span className={isDark ? 'text-blue-400/40' : 'text-gray-400/60'} style={{ fontSize: '11px' }}>
                        (combined {group.entries.length} consecutive {group.entries.length === 1 ? 'event' : 'events'})
                      </span>
                    )}
                  </div>

                  {/* Duration badge */}
                  <span className={`ml-auto px-2.5 py-1 rounded-full text-[11px] font-semibold border flex-shrink-0 ${
                    isOnline
                      ? isDark ? 'bg-green-500/10 text-green-400 border-green-500/30' : 'bg-green-100 text-green-700 border-green-600'
                      : isDark ? 'bg-gray-500/10 text-gray-400 border-gray-500/30' : 'bg-gray-100 text-gray-600 border-gray-300'
                  }`}>
                    {isOnline ? '🟢' : '⚫'} {group.duration}
                  </span>
                </div>
              );
            })}
          </div>

        ) : history && history.length === 0 ? (
          <p className={`text-xs italic ${historyText}`}>No device status history available for this device.</p>
        ) : (
          <p className={`text-xs italic ${historyText}`}>Click the chevron to load history...</p>
        )}
      </div>
    );
  };

  // ── MOBILE DEVICE CARD ──────────────────────────────────────────────────
  const DeviceCard = ({ device, isSelected, onSelect }) => {
   // const isOnline = device.last_status === 'ONLINE' || device.last_status === 'HEARTBEAT';
    const expanded = expandedDeviceRows[device._id];
    return (
      <div className={`overflow-hidden border rounded-xl transition-colors ${
        isSelected
          ? isDark ? 'bg-red-900/15 border-red-700/50' : 'bg-red-50 border-red-300'
          : isDark ? 'border-blue-700/60 bg-richblue-800/20' : 'border-gray-300 bg-gray-50'
      }`}>
        <div
          className={`flex items-center p-2 transition-colors cursor-pointer ${isDark ? 'hover:bg-blue-950/30' : 'hover:bg-gray-100'}`}
          onClick={() => handleDeviceClick(device)}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onSelect(e, device._id)}
            onClick={(e) => e.stopPropagation()}
            className={`flex-shrink-0 w-4 h-4 mr-1 rounded cursor-pointer ${
              isDark 
                ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50'
                : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'
            }`}
          />
          <button
            className={`flex-shrink-0 p-1 transition-colors rounded ${isDark ? 'text-blue-400 hover:bg-blue-800/30' : 'text-gray-600 hover:bg-gray-200'}`}
            onClick={(e) => { e.stopPropagation(); toggleDeviceRow(device._id); }}
            title="View device status history"
          >
            {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </button>
          <div className={`flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-800 ${isDark ? 'border-blue-400/30' : 'border-blue-400'}`}>
            {device.device_name?.charAt(0) || 'D'}
          </div>
          <div className="flex-1 min-w-0">
            <p className={`pl-2 text-sm font-medium truncate ${isDark ? 'text-white' : 'text-gray-900'}`}>{device.device_name}</p>
            <p className={`pl-2 text-xs truncate ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{device.device_location}</p>
          </div>
          <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-xs font-semibold ${getLastStatusBadge(device.last_status)}`}>
            {device.last_status}
          </span>
        </div>

        <div className={`flex flex-wrap items-center justify-between px-3 pb-2 text-xs border-t border-b-2 gap-x-4 gap-y-1 ${isDark ? 'text-blue-300/70 border-blue-800/30' : 'text-gray-600 border-gray-300'}`}>
          <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Code: <span className="font-extralight">{device.device_code}</span></p>
          <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Firmware: <span className='font-extralight'>{device.device_firmware_version}</span></p>
          <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Users: <span className={isDark ? 'text-blue-200 font-extralight' : 'text-blue-700 font-extralight'}>{device.users_count || 0} user(s)</span></p>
          {role === ACCOUNT_TYPE.ORGANIZATION && device.device_manager_id?.manager_name && (
            <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Manager: <span className={isDark ? 'text-blue-200 font-extralight' : 'text-blue-700 font-extralight'}>{device.device_manager_id.manager_name}</span></p>
          )}
          <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Last seen: <span className="font-extralight">{formatDate(device.device_last_seen)}</span></p>
        </div>

        {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
          <div className="flex justify-end gap-2 px-3 pb-3 mt-2">
            <button
              onClick={(e) => handleEditClick(e, device)}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs transition-colors ${
                isDark 
                  ? 'text-yellow-300 bg-yellow-600/30 hover:bg-yellow-600/30'
                  : 'text-yellow-500 bg-yellow-100/20 hover:bg-yellow-200'
              } rounded-lg`}
            >
              <Edit2 className="w-3.5 h-3.5" /> Edit
            </button>
            <button
              onClick={(e) => handleDeleteClick(e, device)}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs transition-colors ${
                isDark
                  ? 'text-red-400 bg-red-600/20 hover:bg-red-600/30'
                  : 'text-red-700 bg-red-100 hover:bg-red-200'
              } rounded-lg`}
            >
              <Trash2 className="w-3.5 h-3.5" /> Delete
            </button>
          </div>
        )}

        {expanded && (
          <div className={`px-3 pt-2 pb-3 border-t ${isDark ? 'border-blue-500/20 bg-white/5' : 'border-gray-300 bg-gray-50'}`}>
            <StatusHistoryPanel device={device} />
          </div>
        )}
      </div>
    );
  };

  if (loading) return <StandardSpinner />;

  const totalCols =
    role === ACCOUNT_TYPE.ORGANIZATION ? 11
    : (role === ACCOUNT_TYPE.MANAGER ? 10 : 9);

  // Theme-aware table styles
  const tableBg = isDark ? 'bg-richblue-800/20' : 'bg-white';
  const tableBorder = isDark ? 'border-blue-700/80' : 'border-gray-300';
  const tableHeaderBg = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  const tableHeaderText = isDark ? 'text-blue-300' : 'text-gray-700';
  //const tableRowBorder = isDark ? 'border-blue-800/60' : 'border-gray-200';
  const tableRowHover = isDark ? 'hover:bg-blue-950/30' : 'hover:bg-gray-50';
  const tableRowSelected = isDark ? 'bg-red-900/10' : 'bg-red-50';

  return (
    <div className={`flex flex-col h-full font-sans transition-colors duration-300 ${isDark ? 'text-white bg-richblue-950' : 'text-gray-900 bg-gray-50'}`}>

      {/* ── HEADER ── */}
      <div className={`flex-none p-3 md:p-4 ${isDark ? 'bg-richblue-950' : 'bg-white'} transition-colors duration-300`}>
        <div className="flex items-center justify-between mb-4">
          <h1 className={`text-xl font-bold md:text-2xl bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent`}>
            Device Management
          </h1>
          {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
            <button
              onClick={handleAddClick}
              className="flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-2 text-sm font-medium text-white shadow-lg bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 rounded-xl shadow-blue-600/25"
            >
              <Plus className="w-4 h-4" />
              <span className="hidden sm:inline">Add Device</span>
              <span className="sm:hidden">Add</span>
            </button>
          )}
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 gap-2 mb-3 sm:mb-4 md:grid-cols-4 md:gap-3">
          {[
            { label: 'Total Devices', value: devices.length, color: isDark ? 'text-white' : 'text-gray-900' },
            { label: 'Active', value: devices.filter(d => d.last_status === 'HEARTBEAT' || d.last_status === 'ONLINE').length, color: isDark ? 'text-green-400' : 'text-green-600' },
            { label: 'Inactive', value: devices.filter(d => d.last_status === 'OFFLINE').length, color: isDark ? 'text-blue-200' : 'text-blue-600' },
            { label: 'Total Users', value: devices.reduce((acc, d) => acc + (d.users_count || 0), 0), color: isDark ? 'text-white' : 'text-gray-900' },
          ].map((stat, idx) => (
            <div key={idx} className={`p-3 border md:p-4 ${isDark ? 'bg-richblue-600/20 border-blue-700/80' : 'bg-gray-100 border-gray-300'} rounded-xl transition-colors duration-300`}>
              <p className={`text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} md:text-sm`}>{stat.label}</p>
              <p className={`mt-1 text-xl font-bold ${stat.color} md:text-2xl`}>{stat.value}</p>
            </div>
          ))}
        </div>

        {/* Search + Filter */}
        <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
          <div className="relative flex-1">
            <input
              type="text"
              placeholder="Search by name, code, location..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={`w-full py-2 pr-4 text-sm border rounded-lg pl-9 ${isDark 
                ? 'bg-richblue-600/20 border-blue-700/80 text-white placeholder-blue-400/40' 
                : 'bg-gray-100 border-gray-300 text-gray-900 placeholder-gray-400'} focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
            />
            <svg className={`absolute left-2.5 top-2.5 h-4 w-4 ${isDark ? 'text-blue-400/60' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className={`px-3 py-2 text-sm border rounded-lg ${isDark 
              ? 'bg-richblue-600/20 border-blue-700/80 text-white' 
              : 'bg-gray-100 border-gray-300 text-gray-900'} focus:outline-none focus:ring-2 focus:ring-blue-700 sm:w-36 transition-colors duration-300`}
          >
            <option value="all">All Status</option>
            <option value="ONLINE">Online</option>
            <option value="OFFLINE">Offline</option>
          </select>
          <div className={`flex items-center justify-center px-3 py-2 text-xs border rounded-lg ${isDark 
            ? 'bg-blue-600/20 border-blue-700/80 text-blue-300' 
            : 'bg-blue-100/20 border-blue-300 text-blue-700'} sm:whitespace-nowrap transition-colors duration-300`}>
            {filteredDevices.length} {filteredDevices.length === 1 ? 'device' : 'devices'} found
          </div>
        </div>
      </div>

      {/* ── BULK ACTION BAR ── */}
      {someSelected && (role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
        <div className={`flex items-center justify-between gap-3 px-3 py-2.5 mx-3 sm:mx-4 mb-2 rounded-xl border ${isDark ? 'border-red-700/50 bg-red-900/20' : 'border-red-300 bg-red-50'} transition-colors duration-300`}>
          <div className={`flex items-center gap-2 text-sm ${isDark ? 'text-red-300' : 'text-red-700'}`}>
            <CheckIcon className="w-4 h-4" />
            <span className="font-medium">{selectedIds.size} device{selectedIds.size > 1 ? 's' : ''} selected</span>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={clearSelection} className={`px-3 py-1.5 text-xs border rounded-lg ${isDark 
              ? 'text-blue-100 border-blue-400/80 hover:bg-blue-800/30' 
              : 'text-gray-700 border-gray-400 hover:bg-gray-200'} transition-colors`}>
              Clear
            </button>
            <button
              onClick={() => setIsBulkDeleteOpen(true)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors"
            >
              <Trash2 className="w-3.5 h-3.5" /> Delete Selected
            </button>
          </div>
        </div>
      )}

      {/* ── MOBILE: Card List ── */}
      <div className="flex flex-col flex-1 gap-3 px-3 pb-4 overflow-y-auto md:hidden">
        {filteredDevices.length > 0 && (role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
          <div className="flex items-center justify-between px-1">
            <label className={`flex items-center gap-2 text-xs cursor-pointer select-none ${isDark ? 'text-blue-300' : 'text-gray-700'}`} onClick={toggleSelectAll}>
              <input
                type="checkbox"
                checked={allFilteredSelected}
                onChange={toggleSelectAll}
                className={`w-4 h-4 rounded ${isDark 
                  ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' 
                  : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`}
              />
              Select all ({filteredDevices.length})
            </label>
          </div>
        )}

        {filteredDevices.length > 0 ? (
          filteredDevices.map(device => (
            <DeviceCard
              key={device._id}
              device={device}
              isSelected={selectedIds.has(device._id)}
              onSelect={toggleSelectDevice}
            />
          ))
        ) : (
          <div className={`flex flex-col items-center justify-center py-16 ${isDark ? 'text-blue-400/50' : 'text-gray-400'}`}>
            <Power className="w-10 h-10 mb-3" />
            <p className="text-sm">No devices found matching your criteria</p>
          </div>
        )}
      </div>

      {/* ── DESKTOP: Table ── */}
      <div className="flex-1 hidden px-4 pb-4 md:block">
        <div className={`border shadow-xl ${tableBg} ${tableBorder} rounded-xl ${isDark ? 'shadow-blue-800/60' : 'shadow-gray-300'} transition-colors duration-300`}>
          <div className="overflow-y-auto overflow-x-auto max-h-[500px] rounded-xl">
            <table className="w-full text-left border-collapse">
              <thead className={`sticky top-0 z-10 ${tableHeaderBg} transition-colors duration-300`}>
                <tr className={`border-b ${isDark ? 'border-blue-800/60' : 'border-gray-300'}`}>
                  {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
                    <th className="w-10 p-3">
                      <input
                        type="checkbox"
                        checked={allFilteredSelected}
                        onChange={toggleSelectAll}
                        className={`w-4 h-4 rounded cursor-pointer ${isDark 
                          ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' 
                          : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`}
                      />
                    </th>
                  )}
                  <th className="w-10 p-1"></th>
                  <th className={`p-3 pl-0 font-semibold ${tableHeaderText}`}>Device Name</th>
                  <th className={`p-3 font-semibold ${tableHeaderText}`}>Device Code</th>
                  <th className={`p-3 font-semibold ${tableHeaderText}`}>Location</th>
                  <th className={`p-3 font-semibold ${tableHeaderText}`}>Firmware</th>
                  {role === ACCOUNT_TYPE.ORGANIZATION && (
                    <th className={`p-3 font-semibold ${tableHeaderText}`}>Manager</th>
                  )}
                  <th className={`p-3 font-semibold ${tableHeaderText}`}>Users</th>
                  <th className={`p-3 font-semibold ${tableHeaderText}`}>Status</th>
                  <th className={`p-3 font-semibold ${tableHeaderText}`}>Last Seen</th>
                  {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
                    <th className={`p-3 font-semibold ${tableHeaderText}`}>Actions</th>
                  )}
                </tr>
              </thead>
              <tbody className={`divide-y ${isDark ? 'divide-blue-900/50' : 'divide-gray-200'}`}>
                {filteredDevices.length > 0 ? (
                  filteredDevices.map((device) => {
                    const isSelected = selectedIds.has(device._id);
                    return (
                      <React.Fragment key={device._id}>
                        <tr
                          className={`transition-colors cursor-pointer ${tableRowHover} ${isSelected ? tableRowSelected : ''}`}
                          onClick={() => handleDeviceClick(device)}
                        >
                          {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
                            <td className="p-3" onClick={(e) => e.stopPropagation()}>
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={(e) => toggleSelectDevice(e, device._id)}
                                className={`w-4 h-4 rounded cursor-pointer ${isDark 
                                  ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' 
                                  : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`}
                              />
                            </td>
                          )}
                          <td
                            className="w-10 p-1"
                            onClick={(e) => { e.stopPropagation(); toggleDeviceRow(device._id); }}
                          >
                            <button
                              className={`flex items-center justify-center p-1 transition-colors rounded ${isDark ? 'text-blue-400 hover:bg-blue-800/30' : 'text-gray-600 hover:bg-gray-200'}`}
                              title="View device status history"
                            >
                              {expandedDeviceRows[device._id]
                                ? <ChevronUp className="w-4 h-4" />
                                : <ChevronDown className="w-4 h-4" />}
                            </button>
                          </td>
                          <td className="p-3 pl-0">
                            <div className="flex items-center gap-3">
                              <div className={`flex items-center justify-center w-10 h-10 font-bold text-white border rounded-full bg-gradient-to-br from-blue-600 to-blue-800 ${isDark ? 'border-blue-400/30' : 'border-blue-400'}`}>
                                {device.device_name?.charAt(0) || 'D'}
                              </div>
                              <span className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>{device.device_name}</span>
                            </div>
                          </td>
                          <td className={`p-3 font-mono text-sm ${isDark ? 'text-blue-300/80' : 'text-blue-700'}`}>{device.device_code}</td>
                          <td className={`p-3 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>{device.device_location}</td>
                          <td className={`p-3 ${isDark ? 'text-white' : 'text-gray-900'}`}>{device.device_firmware_version}</td>
                          {role === ACCOUNT_TYPE.ORGANIZATION && (
                            <td className={`p-3 ${isDark ? 'text-blue-400' : 'text-blue-700'}`}>{device.device_manager_id?.manager_name || 'N/A'}</td>
                          )}
                          <td className="p-3">
                            <span className={`px-2 py-1 text-xs rounded-lg ${isDark ? 'bg-blue-600/20 text-blue-300' : 'bg-blue-100/20 text-blue-700'}`}>
                              {device.users_count || 0} user(s)
                            </span>
                          </td>
                          <td className="p-3">
                            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getLastStatusBadge(device.last_status)}`}>
                              {device.last_status}
                            </span>
                          </td>
                          <td className={`p-3 text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{formatDate(device.device_last_seen)}</td>
                          {(role === ACCOUNT_TYPE.MANAGER || role === ACCOUNT_TYPE.ORGANIZATION) && (
                            <td className="p-3">
                              <div className="flex items-center gap-2">
                                <button
                                  onClick={(e) => handleEditClick(e, device)}
                                  className={`p-2 transition-colors rounded-lg ${isDark ? 'text-blue-400 bg-blue-600/20 hover:bg-blue-600/30' : 'text-blue-700 bg-blue-100/20 hover:bg-blue-200/30'}`}
                                  title="Edit Device"
                                >
                                  <Edit2 className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => handleDeleteClick(e, device)}
                                  className={`p-2 transition-colors rounded-lg ${isDark ? 'text-red-400 bg-red-600/20 hover:bg-red-600/30' : 'text-red-700 bg-red-100 hover:bg-red-200'}`}
                                  title="Delete Device"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>

                        {/* Expanded Device Status History Row */}
                        {expandedDeviceRows[device._id] && (
                          <tr className={`border-t ${isDark ? 'bg-white/5 border-blue-500/20' : 'bg-gray-50 border-gray-300'}`}>
                            <td colSpan={totalCols} className="px-6 py-4">
                              <StatusHistoryPanel device={device} />
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={totalCols} className={`p-8 text-center ${isDark ? 'text-blue-400/60' : 'text-gray-400'}`}>
                      No devices found matching your criteria
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── BULK DELETE MODAL ── */}
      {isBulkDeleteOpen && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 ${isDark ? 'bg-black/60' : 'bg-black/40'} backdrop-blur-sm`} onClick={() => !isBulkDeleting && setIsBulkDeleteOpen(false)}>
          <div className={`w-full border sm:max-w-md ${modalBg} ${isDark ? 'border-red-700/50' : 'border-red-300'} rounded-2xl sm:mb-0 mb-[200px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-center pt-3 pb-1 sm:hidden">
              <div className={`w-10 h-1 ${isDark ? 'bg-gray-600' : 'bg-gray-300'} rounded-full`} />
            </div>
            <div className="p-5 space-y-4 sm:p-6">
              <div className="flex items-start gap-3">
                <div className={`flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full ${isDark ? 'bg-red-600/20' : 'bg-red-100'}`}>
                  <Trash2 className={`w-5 h-5 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
                </div>
                <div>
                  <h3 className={`text-base font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>Delete {selectedIds.size} Device{selectedIds.size > 1 ? 's' : ''}?</h3>
                  <p className={`mt-1 text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                    This will permanently delete {selectedIds.size === 1 ? 'the selected device' : `all ${selectedIds.size} selected devices`}. This action cannot be undone.
                  </p>
                </div>
              </div>

              <div className={`p-3 space-y-1 overflow-y-auto border rounded-lg max-h-32 ${isDark ? 'border-red-800/30 bg-red-900/10' : 'border-red-200 bg-red-50'}`}>
                {[...selectedIds].map(id => {
                  const d = devices.find(d => d._id === id);
                  return d ? (
                    <div key={id} className="flex items-center gap-2 text-sm">
                      <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-[10px] font-bold text-white">
                        {d.device_name?.charAt(0)}
                      </div>
                      <span className={`${isDark ? 'text-white' : 'text-gray-900'} truncate`}>{d.device_name}</span>
                      <span className={`flex-shrink-0 ml-auto text-xs ${isDark ? 'text-blue-400/50' : 'text-blue-600/50'}`}>{d.device_code}</span>
                    </div>
                  ) : null;
                })}
              </div>

              {isBulkDeleting && (
                <div className="space-y-2">
                  <div className={`flex justify-between text-xs ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                    <span>Deleting devices...</span>
                    <span>{bulkProgress.current} / {bulkProgress.total}</span>
                  </div>
                  <div className={`w-full h-2 rounded-full ${isDark ? 'bg-richblue-900' : 'bg-gray-200'}`}>
                    <div
                      className="h-2 transition-all duration-300 bg-red-600 rounded-full"
                      style={{ width: `${bulkProgress.total > 0 ? (bulkProgress.current / bulkProgress.total) * 100 : 0}%` }}
                    />
                  </div>
                </div>
              )}

              <div className="flex gap-3 pb-2 sm:pb-0">
                <button
                  type="button"
                  onClick={() => setIsBulkDeleteOpen(false)}
                  disabled={isBulkDeleting}
                  className={`flex-1 py-2.5 text-sm font-medium rounded-lg border ${isDark 
                    ? 'text-blue-300 border-blue-800/60 hover:bg-blue-800/20' 
                    : 'text-gray-700 border-gray-300 hover:bg-gray-100'} transition-colors disabled:opacity-50`}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleBulkDeleteConfirm}
                  disabled={isBulkDeleting}
                  className="flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isBulkDeleting
                    ? <><Loader2 className="w-4 h-4 animate-spin" /> Deleting...</>
                    : <><Trash2 className="w-4 h-4" /> Delete {selectedIds.size} Device{selectedIds.size > 1 ? 's' : ''}</>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── CREATE / EDIT MODAL ── */}
      {isFormModalOpen && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/60' : 'bg-black/40'} backdrop-blur-sm`} onClick={closeModals}>
          <div
            className={`w-full sm:max-w-md border ${modalBg} ${isDark ? 'border-blue-700/50' : 'border-gray-300'} rounded-2xl max-h-[90vh] overflow-y-auto sm:mb-0 mb-[50px] transition-colors duration-300`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`sticky top-0 z-10 flex items-center justify-between p-4 border-b md:p-6 ${isDark ? 'border-blue-800/40 bg-richblue-950' : 'border-gray-200 bg-white'}`}>
              <h2 className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} md:text-xl`}>
                {formMode === 'create' ? 'Add New Device' : 'Edit Device'}
              </h2>
              <button onClick={closeModals} className={`p-2 transition-colors rounded-lg ${isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100'}`}>
                <X className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-600'}`} />
              </button>
            </div>
            <form onSubmit={handleFormSubmit} className="p-4 space-y-4 md:p-6">
              {[
                { name: 'device_name', label: 'Device Name', icon: Power, readOnly: false },
                { name: 'device_code', label: 'Device Code', icon: Code, readOnly: formMode !== 'create' },
                { name: 'secret_key', label: 'Secret Key', icon: Key, readOnly: formMode !== 'create' },
                { name: 'device_location', label: 'Location', icon: MapPin, readOnly: false },
                { name: 'device_firmware_version', label: 'Firmware Version', icon: Cpu, readOnly: false },
              ].map(({ name, label, icon: Icon, readOnly }) => (
                <div key={name}>
                  <label className={`block mb-1.5 text-sm font-medium ${isDark ? 'text-blue-200' : 'text-gray-700'}`}>
                    <Icon className={`inline w-4 h-4 mr-1 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                    {label} *
                  </label>
                  <input
                    type="text"
                    name={name}
                    value={formData[name]}
                    onChange={handleInputChange}
                    readOnly={readOnly}
                    className={`w-full px-4 py-2.5 ${inputBg} border ${formErrors[name] ? 'border-red-500/50' : inputBorder} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 ${isDark ? 'text-white placeholder-blue-400/40' : 'text-gray-900 placeholder-gray-400'} text-sm ${readOnly ? 'opacity-60 cursor-not-allowed' : ''} transition-colors duration-300`}
                    placeholder={`Enter ${label.toLowerCase()}`}
                  />
                  {formErrors[name] && <p className="mt-1 text-xs text-red-400">{formErrors[name]}</p>}
                </div>
              ))}

              {role === ACCOUNT_TYPE.ORGANIZATION && (
                <div>
                  <label className={`block mb-1.5 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>
                    <User className={`inline w-4 h-4 mr-1 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                    Manager *
                  </label>
                  <select
                    name="managerId"
                    value={formData.managerId}
                    onChange={handleInputChange}
                    required
                    className={`w-full px-4 py-2.5 text-sm border rounded-lg ${inputBg} ${inputBorder} focus:outline-none focus:ring-2 focus:ring-blue-700 ${isDark ? 'text-white' : 'text-gray-900'} transition-colors duration-300`}
                  >
                    <option value="">Select Manager</option>
                    {managersList.map(manager => (
                      <option key={manager._id} value={manager._id}>
                        {manager.manager_name} ({manager.manager_email})
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="flex gap-3 pt-2">
                <button type="button" onClick={closeModals} className={`flex-1 px-4 py-2.5 border ${isDark ? 'border-blue-800/60 hover:bg-blue-600/10 text-blue-300' : 'border-gray-300 hover:bg-gray-100 text-gray-700'} text-sm font-medium rounded-lg transition-colors`}>
                  Cancel
                </button>
                <button type="submit" disabled={formLoading} className="flex-1 px-4 py-2.5 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
                  {formLoading ? (
                    <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Saving...</>
                  ) : (
                    <><Save className="w-4 h-4" />{formMode === 'create' ? 'Create' : 'Update'}</>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── DELETE DEVICE MODAL ── */}
      {isDeleteModalOpen && deviceToDelete && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/60' : 'bg-black/40'} backdrop-blur-sm`} onClick={closeModals}>
          <div className={`w-full border sm:max-w-md ${modalBg} ${isDark ? 'border-red-700/50' : 'border-red-300'} rounded-2xl sm:mb-0 mb-[200px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
            <div className="p-6 text-center">
              <div className={`flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 md:w-16 md:h-16 ${isDark ? 'bg-red-600/20' : 'bg-red-100'}`}>
                <AlertTriangle className={`${isDark ? 'text-red-400' : 'text-red-600'} w-7 h-7 md:w-8 md:h-8`} />
              </div>
              <h2 className={`mb-2 text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} md:text-xl`}>Delete Device</h2>
              <p className={`mb-6 text-sm ${isDark ? 'text-blue-200/70' : 'text-gray-600'}`}>
                Are you sure you want to delete "<span className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>{deviceToDelete.device_name}</span>"? This action cannot be undone.
              </p>
              <div className="flex gap-3">
                <button onClick={closeModals} className={`flex-1 px-4 py-2.5 border ${isDark ? 'border-blue-800/60 hover:bg-blue-600/10 text-blue-300' : 'border-gray-300 hover:bg-gray-100 text-gray-700'} text-sm font-medium rounded-lg transition-colors`}>Cancel</button>
                <button onClick={handleDeleteConfirm} disabled={formLoading} className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
                  {formLoading ? <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Deleting...</> : <><Trash2 className="w-4 h-4" /> Delete</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── UNENROLL MODAL ── */}
      {isUnenrollModalOpen && deviceToUnenroll && (
        <div className={`fixed inset-0 flex items-end sm:items-center justify-center z-[60] p-0 sm:p-4 ${isDark ? 'bg-black/60' : 'bg-black/40'} backdrop-blur-sm`} onClick={closeModals}>
          <div className={`w-full border sm:max-w-md ${modalBg} ${isDark ? 'border-yellow-700/50' : 'border-yellow-300'} rounded-t-2xl sm:rounded-2xl transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
            <div className="p-6 text-center">
              <div className={`flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 ${isDark ? 'bg-yellow-600/20' : 'bg-yellow-100/20'}`}>
                <AlertTriangle className={`${isDark ? 'text-yellow-400' : 'text-yellow-600'} w-7 h-7`} />
              </div>
              <h2 className={`mb-2 text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} md:text-xl`}>Unenroll All Users</h2>
              <p className={`mb-3 text-sm ${isDark ? 'text-blue-200/70' : 'text-gray-600'}`}>Are you sure you want to unenroll all users from "<span className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>{deviceToUnenroll.device_name}</span>"?</p>
              <p className={`mb-6 text-xs ${isDark ? 'text-yellow-400/80' : 'text-yellow-700'}`}>This will remove all enrolled fingerprints from this device. Users will need to enroll again.</p>
              <div className="flex gap-3">
                <button onClick={closeModals} className={`flex-1 px-4 py-2.5 border ${isDark ? 'border-blue-800/60 hover:bg-blue-600/10 text-blue-300' : 'border-gray-300 hover:bg-gray-100 text-gray-700'} text-sm font-medium rounded-lg transition-colors`}>Cancel</button>
                <button onClick={handleUnenrollConfirm} disabled={formLoading} className="flex-1 px-4 py-2.5 bg-yellow-600 hover:bg-yellow-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
                  {formLoading ? <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Unenrolling...</> : <><Users className="w-4 h-4" /> Unenroll All</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── DELETE USERS MODAL ── */}
      {isDeleteUserModalOpen && deleteUserFromDevice && (
        <div className={`fixed inset-0 flex items-end sm:items-center justify-center z-[60] p-0 sm:p-4 ${isDark ? 'bg-black/60' : 'bg-black/40'} backdrop-blur-sm`} onClick={closeModals}>
          <div className={`w-full border sm:max-w-md ${modalBg} ${isDark ? 'border-yellow-700/50' : 'border-yellow-300'} rounded-t-2xl sm:rounded-2xl transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
            <div className="p-6 text-center">
              <div className={`flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 ${isDark ? 'bg-yellow-600/20' : 'bg-yellow-100'}`}>
                <AlertTriangle className={`${isDark ? 'text-yellow-400' : 'text-yellow-600'} w-7 h-7`} />
              </div>
              <h2 className={`mb-2 text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} md:text-xl`}>Delete All Users</h2>
              <p className={`mb-3 text-sm ${isDark ? 'text-blue-200/70' : 'text-gray-600'}`}>Are you sure you want to delete all users from "<span className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>{deleteUserFromDevice.device_name}</span>"?</p>
              <p className={`mb-6 text-xs ${isDark ? 'text-yellow-400/80' : 'text-yellow-700'}`}>This will remove all users from this device. Users will need to create and enroll again.</p>
              <div className="flex gap-3">
                <button onClick={closeModals} className={`flex-1 px-4 py-2.5 border ${isDark ? 'border-blue-800/60 hover:bg-blue-600/10 text-blue-300' : 'border-gray-300 hover:bg-gray-100 text-gray-700'} text-sm font-medium rounded-lg transition-colors`}>Cancel</button>
                <button onClick={handleDeleteUsers} disabled={formLoading} className="flex-1 px-4 py-2.5 bg-yellow-600 hover:bg-yellow-500 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
                  {formLoading ? <><div className="w-4 h-4 border-2 rounded-full border-white/30 border-t-white animate-spin" /> Deleting...</> : <><Users className="w-4 h-4" /> Delete All</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── VIEW DEVICE MODAL ── */}
      {isModalOpen && selectedDevice && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/60' : 'bg-black/40'} backdrop-blur-sm`} onClick={closeModals}>
          <div
            className={`${modalBg} border ${isDark ? 'border-blue-700/50' : 'border-gray-300'} rounded-t-2xl sm:rounded-2xl w-full sm:max-w-4xl max-h-[90vh] sm:max-h-[80vh] overflow-y-auto transition-colors duration-300`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`sticky top-0 z-10 flex items-center justify-between p-4 border-b md:p-6 ${isDark ? 'bg-richblue-950/95 backdrop-blur-sm border-blue-800/40' : 'bg-white/95 backdrop-blur-sm border-gray-200'}`}>
              <h2 className={`flex items-center gap-2 text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} md:text-2xl`}>
                <Power className={`w-5 h-5 ${isDark ? 'text-blue-500' : 'text-blue-600'} md:w-6 md:h-6`} />
                Device Details
              </h2>
              <button onClick={closeModals} className={`p-2 transition-colors rounded-lg ${isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100'}`}>
                <X className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-600'} md:w-6 md:h-6`} />
              </button>
            </div>

            <div className="p-4 space-y-4 md:p-6 md:space-y-6">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
                <div className={`p-4 border ${isDark ? 'bg-richblue-950 border-blue-800/40' : 'bg-white border-gray-200'} rounded-xl transition-colors duration-300`}>
                  <h3 className={`flex items-center gap-2 mb-3 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'} md:text-base`}>
                    <Power className="w-4 h-4" /> Basic Information
                  </h3>
                  <div className="space-y-2 text-sm">
                    {[
                      ['Device Name', selectedDevice.device_name, isDark ? 'text-white font-medium' : 'text-gray-900 font-medium'],
                      ['Device Code', selectedDevice.device_code, isDark ? 'font-mono text-gray-300' : 'font-mono text-gray-600'],
                      ['Secret Key', selectedDevice.secret_key, isDark ? 'font-mono text-gray-400' : 'font-mono text-gray-500'],
                      ['Location', selectedDevice.device_location, isDark ? 'text-white' : 'text-gray-900'],
                      ['Firmware', selectedDevice.device_firmware_version, isDark ? 'text-white' : 'text-gray-900'],
                      ['Manager', selectedDevice.device_manager_id?.manager_name || 'N/A', isDark ? 'text-white' : 'text-gray-900'],
                    ].map(([label, val, cls]) => (
                      <div key={label} className="flex justify-between gap-2">
                        <span className={`flex-shrink-0 ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>{label}</span>
                        <span className={`${cls} text-right break-all`}>{val}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className={`p-4 border ${isDark ? 'bg-richblue-950 border-blue-800/40' : 'bg-white border-gray-200'} rounded-xl transition-colors duration-300`}>
                  <h3 className={`flex items-center gap-2 mb-3 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'} md:text-base`}>
                    <Wifi className="w-4 h-4" /> Status Information
                  </h3>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className={isDark ? 'text-blue-400' : 'text-blue-600'}>Device Status</span>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusBadge(selectedDevice.last_status)}`}>
                        {selectedDevice.last_status === 'ONLINE' || selectedDevice.last_status === 'HEARTBEAT' ? 'ACTIVE' : 'INACTIVE'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={isDark ? 'text-blue-400' : 'text-blue-600'}>Last Status</span>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getLastStatusBadge(selectedDevice.last_status)}`}>
                        {selectedDevice.last_status}
                      </span>
                    </div>
                    <div className="flex justify-between gap-2">
                      <span className={`flex-shrink-0 ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>Last Seen</span>
                      <span className={`text-right ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{formatDate(selectedDevice.device_last_seen)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className={isDark ? 'text-blue-400' : 'text-blue-600'}>Users Count</span>
                      <span className={`font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>{selectedDevice.users_count || 0}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`p-4 border ${isDark ? 'bg-richblue-950 border-blue-800/40' : 'bg-white border-gray-200'} rounded-xl transition-colors duration-300`}>
                <h3 className={`flex items-center gap-2 mb-3 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'} md:text-base`}>
                  <Users className="w-4 h-4" /> References
                </h3>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                  <div>
                    <p className={`text-xs ${isDark ? 'text-blue-400' : 'text-blue-600'} mb-0.5`}>Organization</p>
                    <p className={`font-mono text-sm ${isDark ? 'text-white' : 'text-gray-900'} break-all`}>{selectedDevice.org_id?.org_name || 'N/A'}</p>
                  </div>
                  <div>
                    <p className={`text-xs ${isDark ? 'text-blue-400' : 'text-blue-600'} mb-0.5`}>Manager</p>
                    <p className={`font-mono text-sm ${isDark ? 'text-white' : 'text-gray-900'} break-all`}>{selectedDevice.device_manager_id?.manager_name || 'N/A'}</p>
                  </div>
                  <div>
                    <p className={`text-xs ${isDark ? 'text-blue-400' : 'text-blue-600'} mb-0.5`}>Version</p>
                    <p className={`text-sm ${isDark ? 'text-white' : 'text-gray-900'}`}>v{selectedDevice.__v}</p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <div className={`p-4 border ${isDark ? 'bg-richblue-950 border-blue-800/40' : 'bg-white border-gray-200'} rounded-xl transition-colors duration-300`}>
                  <h3 className={`mb-2 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>Created</h3>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>By: {selectedDevice.createdBy || 'N/A'}</p>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>At: {formatDate(selectedDevice.createdAt)}</p>
                </div>
                <div className={`p-4 border ${isDark ? 'bg-richblue-950 border-blue-800/40' : 'bg-white border-gray-200'} rounded-xl transition-colors duration-300`}>
                  <h3 className={`mb-2 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>Last Updated</h3>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>By: {selectedDevice.updatedBy || 'N/A'}</p>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>At: {formatDate(selectedDevice.updatedAt)}</p>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <div
                  onClick={() => handleUnenrollClick(selectedDevice)}
                  className={`p-4 transition-colors border cursor-pointer ${isDark ? 'bg-richblue-950 border-yellow-600/40 hover:bg-yellow-900/20' : 'bg-white border-yellow-300 hover:bg-yellow-50'} rounded-xl`}
                >
                  <h3 className={`inline-block px-3 py-1 text-xs font-semibold border rounded-lg md:text-sm ${isDark ? 'text-yellow-400 bg-yellow-900/30 border-yellow-500/40' : 'text-yellow-500 bg-yellow-100/20 border-yellow-300'}`}>
                    Unenroll All Users
                  </h3>
                  <p className={`mt-2 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                    This will remove all enrolled fingerprints from this device. Users will need to enroll again.
                  </p>
                </div>
                <div
                  onClick={() => handleDeleteUserClick(selectedDevice)}
                  className={`p-4 transition-colors border cursor-pointer ${isDark ? 'bg-richblue-950 border-yellow-600/40 hover:bg-yellow-900/20' : 'bg-white border-yellow-300 hover:bg-yellow-50'} rounded-xl`}
                >
                  <h3 className={`inline-block px-3 py-1 text-xs font-semibold border rounded-lg md:text-sm ${isDark ? 'text-yellow-400 bg-yellow-900/30 border-yellow-500/40' : 'text-yellow-500 bg-yellow-100/20 border-yellow-300'}`}>
                    Delete All Users
                  </h3>
                  <p className={`mt-2 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                    This will remove all users from this device. Users will need to create and enroll again.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceManagement;
